export default {
  nameResolution: {
    requiredFailed:
      '必要な面 {{name}} が対応しませんでした。メッシュ生成前に抽出結果を確認してください。',
    requiredFailedCoolant:
      '名前 {{name}} が切り出した冷却材に対応しませんでした。境界割り当てで確認してから、もう一度切り出してください。',
    highlight: '{{name}} をハイライト',
    loading: '名前付き表面の結果を読み込み中…',
    loadFailed: '名前付き表面の結果を読み込めませんでした。',
    retry: '再試行',
    title: '名前付き表面',
    landed: '適用済み',
    failed: '失敗',
    coverage: '準備済み表面の {{share}}',
    coverageUnavailable: '表面の割合は不明です',
    mergedInto: '{{name}} に統合',
    reason: {
      not_boundary_opening:
        'この開口部は冷却流路の境界上にありません。別の検出された開口部を選んでください。',
      no_cad_record: 'この名前に対応する CAD 面の記録がありません。',
      normal_disagreement:
        '抽出された面がこの壁と一致しません。流路サイズを変更しても改善しません。',
      no_match_in_band:
        '抽出処理でこの壁を解決できませんでした。流路サイズを変更しても改善しません。',

      spatial_match_failed: '一致する準備済み表面が見つかりませんでした。',
      ambiguous_match: 'この面に一致する表面が複数あります。',
      no_descriptors: '元の CAD 面の情報がありません。',
      resolved: '結果の表面が記録されていません。',
      merged: '統合された名前の結果の表面が記録されていません。',
      // 予約済みパッチ名はメッシュ時にリネームされる (ENG-3076)。
      renamed:
        'この名前は予約されているため、生成されたパッチ名で適用されました。',
    },
  },
  // メッシュドット / リトライログ / ファイルツリー用の MeshStatus ラベル
  // (ENG-1744). 語彙は既存カタログ (simopsMisc.statusBadge,
  // simopsFiles.studyTree.quality*) に合わせている. `recombining` は
  // `meshing` と同じ文言 — 再結合はメッシュ生成の内部工程であり、
  // ユーザーが操作できない段階名を出さない.
  meshStatus: {
    completed: '完了',
    failed: '失敗',
    meshing: 'メッシュ化中...',
    recombining: 'メッシュ化中...',
    pending: '保留中',
    cancelled: 'キャンセル済み',
  },
  failureMessage: {
    // BE が返す典型的な pipeline 失敗メッセージの日本語文案.
    // utils/failureMessage.ts:translateFailureMessage が「クリーン化
    // 済み」の英文原文に正規表現で照合し、最初にヒットしたものを採用.
    stlNotWatertight:
      'STL が閉じていません — 開いた辺が検出されました。CAD で開口部を塞いでから再エクスポートしてください。',
    degenerateTriangles:
      'STL に退化 (面積ゼロ) 三角形が含まれます。弦高/角度公差をより細かく設定して再エクスポートしてください。',
    stlUnreadable:
      'STL を読み込めません — ヘッダが壊れている可能性があります。CAD ツールから再エクスポートしてください。',
    stlEmpty:
      'STL に三角形がありません。空ファイルとして書き出された可能性があります — 再エクスポートしてください。',
    stlSingleSolid:
      'STL に命名された solid がないため、パッチ単位のタグ付けはできません — メッシュ化は可能ですが、境界条件はサーフェス全体に適用されます。パッチ別にタグ付けするには「命名 solid を含む ASCII STL」で再エクスポートしてください。',
    selfIntersection:
      '自己交差ジオメトリ — 表面が自分自身と交差しています。CAD で交差を修正 (例: 重なるボディを結合) してから再アップロードしてください。',
    nonManifold:
      '非多様体エッジ — 3 面以上が同じエッジを共有、またはサーフェスに T 字接合があります。CAD でクリーンアップしてください (通常は重なるボディを結合または切除)。',
    pinchPoint:
      'ピンチ点 — 2 つのサーフェスが 1 点のみで接触し、面を共有していません。自動修復はソリッドを崩壊させます; CAD でボディを結合し、面を共有するようにしてください。',
    overlappingFaces:
      '重なった/共面の面 — 2 つのサーフェスが同じ空間を占めています。CAD で冗長なソリッドを結合するか、重複面を削除してください。',
    couldNotHeal:
      '自動修復ではこのジオメトリを治せませんでした。欠陥は CAD 側での修正が必要です — 「簡略化 (ソリッドを結合)」を試すか、CAD ツールで修復して再アップロードしてください。',
    timedOut:
      '診断がタイムアウトしました — ジオメトリが複雑すぎて許容時間内で解析できません。モデルの簡略化や小さな特徴の削除をお試しください。',
    outOfMemory:
      'ジオメトリでアナライザがメモリ不足になりました。アセンブリを分割するか、小さな特徴/重複ボディを削除してください。',
    unsupportedFormat:
      'このファイル形式はサポートされていません。STEP (推奨) または STL で再エクスポートしてください。',
    couldNotRead:
      'ファイルを読み込めませんでした。CAD ツールのデフォルト設定で再エクスポートしてください。',
    zeroVolume:
      'ジオメトリに実体積がありません — サーフェスボディまたはスケッチの可能性があります。メッシュ化には閉じたソリッドが必要です。',
    noGeometry:
      'ファイルにジオメトリが見つかりません。空、点や曲線のみ、またはサポートされていない形式の可能性があります。',
    // メッシュ pipeline (Diagnosis 以降) の失敗メッセージ.
    // MeshResultsPanel で meshResults.error と failedStageReport.message
    // に対して照合される.
    meshTimedOut:
      'この段階を完了する前にメッシュ化がタイムアウトしました。ストラテジタイムアウトを増やす、最小サイズを粗くする、または最大細分レベルを下げてください。',
    meshOutOfMemory:
      'メッシュ化中にメモリ不足になりました。最小サイズを粗くする、最大細分レベルを下げる、またはアセンブリを分割してください。',
    meshPolyBlCrash:
      '多面体メッシャーがクラッシュしました (SIGSEGV)  — 多くは微細なセルサイズや荒れた面での境界層リファイナーが原因です。境界層をオフにするか、最大/最小サイズを粗くして再実行してください。',
    // 「pipeline」= メッシュ化の多段階ワークフロー (Diagnosis →
    // Meshing → Quality → Healing → Conversion). 英字はそのまま
    // 残さず、CFD ワークフロー語境で通じる「作業フロー」を使う.
    meshPipelineFailed:
      'メッシュ作業フローが結果を出す前に停止しました。失敗ステップは下のログとステージレポートを参照してください。',
    meshingFailedGeneric:
      'メッシュ化に失敗しました。失敗ステップは下のログとステージレポートを参照してください。',
    meshAddLayers:
      '今回の実行で境界層の押し出し (snappyHexMesh addLayers) が失敗しました。層数を減らす、第一層高さを下げる、または「BL カバレッジ優先」を有効にしてください。',
    meshSnapFailed:
      'snap 段階 (snappyHexMesh snap) がこのジオメトリで収束しませんでした。特徴角を広げる、Snap Fidelity を有効にする、または CAD を修復してください。',
    meshFaceTagUnresolved:
      '必要な inlet または outlet のタグが、メッシュ対象サーフェスのどの面とも一致しなかったため、メッシュ生成が始まる前に停止しました。これは CAD の問題ではなくラベル付けの問題です。境界割り当てを開き、メッシュソース (流体領域 / ボディ) がタグ付けした面と一致しているか確認し、inlet と outlet を付け直してください。',
    meshBlockmeshFailed:
      'blockMesh がこの実行のバックグラウンドメッシュを構築できませんでした。エンクロージャ係数と BlockMesh セルサイズ上書きを確認してください。',
    meshWireball:
      'snap が退化/非凸セル (wireball) を生成しました。Snap Fidelity を有効化するか、Repair の代わりに Wrap でジオメトリを取り込んでください。',
    meshCellBudget:
      'メッシュがこの実行のセル数上限を超えます。Max Local Cells/Max Global Cells を上げるか、メッシュを粗くしてください (最小サイズを大きく、細分を小さく)。',
    // 各サブステージ固有のタイムアウトメッセージ. {{seconds}} は
    // extractTimeoutSeconds が BE の原文「after Ns」から抽出.
    afterSeconds: ' ({{seconds}} 秒後)',
    assemblySplitIgnored:
      'アセンブリ分割メッシュ化は次の上書き設定を無視しました：{{overrides}}',
    meshSnappyTimedOut:
      'snappyHexMesh (`openfoam_snappy`) がタイムアウトしました{{after}} — ストラテジ予算を使い切っても最終メッシュに至らず。予算切れの時点で実行中だった内部ステップ (blockMesh / snap / addLayers) を上のステージタイムラインで確認してください。対処：最小サイズを粗くする、最大細分レベルを下げる、または「詳細」でストラテジタイムアウトを増やしてください。',
    meshBlockmeshTimedOut:
      'blockMesh (`openfoam_blockmesh`) がバックグラウンドグリッド構築中にタイムアウトしました{{after}}。バックグラウンドメッシュを粗くしてください — BlockMesh セルサイズを大きくするか、エンクロージャを縮めます。',
    meshAddLayersTimedOut:
      'addLayers 段階 (`openfoam.add_layers`) が境界層セルを押し出し中にタイムアウトしました{{after}}。境界層の層数を減らす、第一層高さを下げる、または「BL カバレッジ優先」を有効にしてください。',
    meshSnapTimedOut:
      'snap 段階 (`openfoam.snap`) がメッシュを CAD 特徴エッジにスナップ中にタイムアウトしました{{after}}。特徴角を広げる、Snap Fidelity を有効にする、または CAD を修復してください。',
    meshGmshTimedOut:
      'Gmsh がタイムアウトしました{{after}}。最小サイズを粗くするか、細分レベルを下げてください。',
    // メッシュ化後の品質警告 — 成功したメッシュ化ランで checkMesh が
    // 問題を検出した際に表示される黄色警告. 数値は BE 英文原文から
    // translateMeshWarning で抽出.
    warnHighSkewness:
      '最大歪度 = {{value}}、高歪度な面を {{count}} 個検出しました — これらのセル周辺でソルバ精度が下がる可能性があります。最大細分レベルを上げるか、該当領域の CAD を修復してください。',
    warnHighNonOrtho:
      '最大非直交角 = {{value}}°、高非直交な面を {{count}} 個検出しました — ソルバがより多くの非直交補正を必要とする可能性。非直交補正回数を 3~4 に増やす、または最大非直交角を下げてから再メッシュ化してください。',
    warnHighAspect:
      '最大アスペクト比 = {{value}}、高伸張のセルを {{count}} 個検出しました — 境界層とメインメッシュの繋ぎ目不良が典型。成長比を下げるか、最小サイズを粗くしてください。',
    warnNegativeVolume:
      '負体積セルを {{count}} 個検出しました — この状態のメッシュではソルバを回せません。最小サイズを粗くする、最大細分レベルを下げる、または該当セル周辺の CAD を修復してください。',
    warnCheckMeshFailed:
      '{{count}} 個のセルが checkMesh を通過できませんでした。ソルバは走りますが、これらのセル周辺の結果は信頼性が低下します。品質目標を厳しくするか、再メッシュ化してください。',
    warnBlCoverage:
      '境界層カバレッジ {{actual}}% (目標 {{target}}%)。一部の壁面で層が未生成または部分生成 — 「BL カバレッジ優先」を有効にする、または層数/第一層高さを下げてください。',
    warnZeroNegativeFaceArea:
      'ゼロまたは負の面積を持つ面を検出しました (最小 = {{minArea}})。checkMesh が退化面を検出 — このメッシュではソルバを安全に回せません。最小サイズを粗くする、最大細分レベルを下げる、または該当領域周辺の CAD を修復してください。',
    warnFacePyramids:
      '{{count}} 個の面の向きが不正 (checkMesh facePyramids)。非多様体または法線反転のジオメトリ — 該当領域の CAD を修復するか、最小サイズを粗くして再メッシュ化し、snappy がその位置で退化面を生成しないようにしてください。',
  },
  fastenerInterfaces: {
    title: '検出されたボルト接触面 ({{count}})',
    criteriaTooltip:
      '2 つの円筒が別々のボディにあり、平行で、軸方向に重なり、シャンクがボア内にある場合に一覧へ表示されます。\n\nボア半径はシャンク半径の 4 倍以内である必要があります。この上限がないと、ハウジング（アクスルチューブやハブのボア）が貫通するすべてのボルトを取り込んでしまいます。\n\nすきまと偏心は計測値として表示するだけで、良否は判定しません。リベットは穴を埋め、ショルダーボルトは密着し、長穴ブラケットは意図的に緩いためです。',
    hint: 'ペアを命名すると両方の面にラベルが付きます。接触ペアの設定は SimOps で行い、そこで調整もできます。',
    loadFailed: 'このジオメトリのボルト接触面を読み込めませんでした。',
    notMeasured:
      'このジオメトリではファスナーのはめあいが計測されていません。再度診断を実行してください。',
    legacyDiagnosis_one:
      '{{count}} 件の組み合わせは面の識別情報がないため適用できません。再度診断を実行してください。',
    legacyDiagnosis_other:
      '{{count}} 件の組み合わせは面の識別情報がないため適用できません。再度診断を実行してください。',
    bodyPair: 'ボルト Vol {{shank}} → Vol {{hole}}',
    fit: 'すきま {{clearance}} mm · 偏心 {{eccentricity}} mm',
    interference:
      'シャンクがボア穴より太くなっています。モデルを確認してください。',
    selectPair: 'ボルト Vol {{shank}} → Vol {{hole}} を命名対象に選択',
    applySelected_one: '選択した {{count}} 組に名前を付ける',
    applySelected_other: '選択した {{count}} 組に名前を付ける',
    apply: '面に名前を付ける',
    applied: '命名済み',
    unbindable:
      'これらの面は現在のビューにありません。元のビューに戻すと適用できます。',
    verdict: {
      no_head_seating: '座面なし',
      no_modelled_head: '頭部がモデル化されていません',
    },
    verdictHint: {
      no_head_seating:
        '頭部がボア穴より外側に張り出していないため、締付け力を受ける面がありません。',
      no_modelled_head:
        '軸に対向する平面が見つからなかったため、座面を評価できませんでした。',
    },
  },
  bodyPartName: {
    tooltip: 'CAD ファイルの部品名',
  },
  structuralBodies: {
    title: 'ボディ割り当て',
    description:
      '各ボディに名前と種別を設定します。ジオメトリに保存されるため、以降のすべての工程で同じ名前が使われます。ラベルは表示用のみ — ソルバー側は引き続き Volume_<番号> を使用します。',
    runDiagnosisFirst:
      'ボディがまだありません。このジオメトリで診断を実行してボリュームを一覧表示してください。',
    volumeLabel: 'ボリューム {{index}}',
    labelFor: 'ボリューム {{index}} の名前',
    hideBody: 'ボリューム {{index}} を非表示',
    showBody: 'ボリューム {{index}} を表示',
    roleFor: 'ボリューム {{index}} を{{role}}に設定',
    roleMember: '部材',
    roleFastener: '締結要素',
    roleExcluded: '除外',
    roleMemberTooltip: '荷重を伝達する部材。メッシュ化して解析します。',
    roleFastenerTooltip:
      'ボルト・リベット・ピン。メッシュ化して解析し、結合する部材とは別に結果を報告します。',
    roleExcludedTooltip:
      'メッシュから完全に除外 — 要素も結果も接触も生成されません。',
    detectedBadge: '提案',
    detectedTooltip:
      '締結要素検出による提案で、未確認です。種別を選んで確認または修正してください。',
    save: '割り当てを保存',
    saving: '保存中…',
    savedToast: 'ボディ割り当てを保存しました。',
    conflictToast:
      '他のユーザーがボディ割り当てを変更しました。編集内容は保持されています — 確認して再度保存してください。',
    saveFailedToast:
      'ボディ割り当てを保存できませんでした。再試行してください。',
  },
  bodyClassification: {
    title: 'ボディ分類',
    cavity: 'キャビティ',
    body: 'ボディ',
    cavityTooltip:
      '流体通路（キャビティ STL）を表示します。流体ボリュームにカーソルを合わせると、そのキャビティ面が点灯します。',
    bodyTooltip:
      '壁面ジオメトリ（ボディ STL）を表示します。ソリッドボリュームにカーソルを合わせると、その壁面が点灯します。',
    description:
      '各 CAD ボリュームにマルチ領域 CHT 用の役割を割り当てます。流体領域はちょうど 1 つ、ソリッド領域は 1 つ以上が必要です。',
    meshFromBodyNote:
      '境界割り当ての「メッシュ対象」が「ボディ」に設定されているため、キャビティ表示はオフです。「流体領域」に戻すと、この部品の表面ラベルと境界層の wall 選択がクリアされ、そのあとここで「キャビティ」を選ぶ必要があります。',
    runDiagnosisFirst:
      'まず Diagnosis を実行して CAD ボリュームを検出してください。',
    volumesDetected_one:
      'ボリュームを {{count}} 個検出しました。Diagnosis を再実行してボリュームの詳細を取得してください。',
    volumesDetected_other:
      'ボリュームを {{count}} 個検出しました。Diagnosis を再実行してボリュームの詳細を取得してください。',
    volumeLabel: 'ボリューム {{index}}',
    regionLabelPlaceholder: '領域ラベル',
    invalidLabels:
      'ラベルには英字・数字・アンダースコアのみ使用できます（スペースや特殊文字は不可）。',
    duplicateLabels_one: '重複したラベル：',
    duplicateLabels_other: '重複したラベル：',
    assignOneFluid: 'ボリュームをちょうど 1 つ流体に割り当ててください。 ',
    onlyOneFluid: '流体領域は 1 つのみ許可されます。 ',
    atLeastOneSolid: 'ソリッド領域が少なくとも 1 つ必要です。',
    validSummary:
      '流体 {{fluidCount}} 個 + ソリッド領域 {{solidCount}} 個を設定しました。',
    cavityBadge: '抽出',
    cavityBadgeTooltip:
      '部品内部の空間です。ジオメトリから自動検出したもので、CAD ファイルに含まれるボディではありません。通常はこれが流体です。',
    roleFluid: '流体',
    roleSolid: 'ソリッド',
    roleExclude: '除外',
    descriptionWrap:
      'メッシュ化の前に各部品に名前を付けます。名前はメッシュと SimOps でその部品の領域名になります。',
    coolantRow: '冷却材',
    coolantRowNote:
      '境界割り当てで流路から切り出されるため、CAD の部品ではありません。',
    solidOnlyTooltip:
      'Wrap メッシュでは、すべての CAD 部品がソリッドです。冷却材は流路から切り出されるため流体になる部品はなく、切り出しが変わってしまうため部品を除外することもできません。',
    noHighlight: '3D ビューではまだこれらの部品をハイライトできません。',
    cavityTooltipWrap:
      '切り出した冷却材を、半透明の壁の内側に表示します。見るための表示です。',
    bodyTooltipWrap:
      '部品を表示します。カードにカーソルを合わせると、その部品が点灯します。',
    cavityLookOnlyNote:
      'キャビティ表示は見るためのものです。部品は点灯せず、クリックしても何も選択されません。部品を探すには「ボディ」に切り替えてください。',
    waitingForPartCheck:
      'このアップロードに個別の部品があるか確認中です。確認が終わると、部品がここに表示されます。',
    partsCannotBeNamed: 'このアップロードの部品には名前を付けられません。',
    refusals: {
      blank: '名前を空にすることはできません。',
      tooLong: '「{{label}}」は {{max}} 文字を超えています。',
      folderName: '「{{label}}」は OpenFOAM 自身が使うフォルダー名です。',
      interfaceInfix:
        '「{{label}}」には _to_ が含まれています。OpenFOAM は領域間の壁の名前にこれを使います。',
      interfaceSuffix:
        '「{{label}}」は _to で終わるため、隣接する壁が誤った領域として読み取られます。',
      sameFolder:
        '「{{other}}」と「{{label}}」は大文字・小文字だけが異なり、macOS と Windows では同じフォルダーとして扱われます。',
      sameRegion: '「{{other}}」と「{{label}}」は同じ領域名になります。',
      coolantName: '「{{label}}」は冷却材の名前です。',
      solidName:
        '「{{label}}」は、部品を分離できないときにメッシュが金属部分に付ける名前です。',
      airName:
        '「{{label}}」は閉じ込められた空気の領域（air_0、air_1 など）用に予約されています。',
      otherPartDefault: '「{{label}}」は別の部品の既定の名前です。',
    },
  },
  boundaryAssignment: {
    suggestedLabels: {
      fixed: '固定支持',
      load: '荷重',
      pressure: '圧力',
      symmetry: '対称',
      contact: '接触',
      surface: '表面',
      wall: '壁面',
      inlet: '入口',
      outlet: '出口',
      farfield: '遠方境界',
    },
    title: '境界割り当て',
    preview: 'プレビュー',
    faceLabelsConflictToast:
      '表面ラベルを保存できませんでした。別のセッションで変更されています。最新の状態を読み込むには再読み込みしてください。',
    descriptionFea:
      'SimOps で表面ごとに境界条件を設定できるよう、メッシュ化前に CAD 表面にラベルを付けます。',
    descriptionFlow:
      '各表面に境界の役割を割り当てます。検出された開口はあらかじめラベル付けされ、残りの面は既定で wall になります。',
    descriptionCoolant:
      '冷却材が流れる開口を探し、必要なら名前を付けてから、部品から冷却材を切り出します。名前を空けた開口には自動で名前が付き、名前から流れの向きが分からない開口は SimOps で向きを尋ねます。',
    // ENG-1869 — 英語版のコメント参照。原因も対処法も述べない。
    bodySurfaceFallbackTitle: 'タグ付けはソリッドボディに紐付きます',
    bodySurfaceFallbackBody:
      'このジオメトリでは流体キャビティが抽出されていないため、下に表示されるのはキャビティではなくソリッドボディの表面です。inlet / outlet 面は手動でタグ付けする必要があり、メッシュ化したキャビティはプレビューできません。',
    hideEnclosure: 'エンクロージャを非表示',
    showEnclosure: 'エンクロージャを表示',
    enclosureFaces: 'エンクロージャ面',
    resetAllToDefaults: 'すべて既定値にリセット',
    reset: 'リセット',
    faceReadoutWithDiameter:
      '面ごとの読み値。平面・円筒面… = CAD 上でその面が載る曲面。円筒面は直径付き（STL 部品では表示なし）。Ø = 等価円直径（2·√(area/π)） — 開口サイズの目安であり、非円形面の実寸ではありません。cm² = 面の表面積。n = 外向き単位法線。',
    faceReadout:
      '面ごとの読み値。平面・円筒面… = CAD 上でその面が載る曲面。円筒面は直径付き（STL 部品では表示なし）。cm² = 面の表面積。n = 外向き単位法線。',
    surfaceType: {
      plane: '平面',
      cylinder: '円筒面',
      cone: '円錐面',
      sphere: '球面',
      torus: 'トーラス面',
      bspline: 'B スプライン曲面',
      other: 'その他の曲面',
    },
    wallGroup: 'wall（{{count}}）',
    labelSummary: 'ラベル概要',
    facesCount: '{{count}} 面',
    boundaryRolesTooltip:
      'CFD における各境界の役割の意味：\n• Wall — 固体のノースリップ面。流体が付着します（壁面での速度はゼロ）。\n• Inlet — 流れがここから入ります。速度/流量を設定します。\n• Outlet — 流れがここから出ます。圧力を設定します（通常はゲージ 0）。\n• Symmetry — 何も横切らないミラー面。対称領域の半分だけをメッシュ化できます。\n• Slip — 摩擦のない壁面。流れは通り抜けませんが、沿った抗力もありません。\n• Farfield / Freestream — ボディから遠く、流れが乱されない開放境界（外部流）。',
    sharedBoundaryNotice: '同じ名前の面は 1 つの境界条件を共有します。',
    surfaceZones: '表面ゾーン',
    selectByVolume: 'ボリューム単位で面を選択',
    volumeFaces: 'ボリューム {{index}}・{{count}} 面',
    volumeSelectionHint:
      'ボリュームに属するすべての面を 3D ビューアーで選択します。下の各面で現在の選択に追加または削除できます。',
    selectedFaceName: '選択した {{count}} 面に名前を付ける',
    faceNamePlaceholder: '例: symmetry または fixed',
    renameSelected: '名前を変更',
    surfaceCountTooltip:
      'この部品で検出された個別の表面数です。サーバーからリアルタイムで読み取るため、メッシュ化される表面と常に一致します。',
    loadingSurfaces: '表面を読み込み中…',
    surfacesNotComputed:
      '表面はまだ計算されていません。先に Diagnosis を完了してください。',
    // ENG-1816 — rationale on the en key.
    cavityNotExtracted:
      '先に流体空洞を抽出してください。境界割り当ては固体本体ではなく空洞の面にタグを付けます。Mesh Settings で Extract を実行してから戻ってきてください。',
    noSurfaces:
      '利用できる表面がありません。先に Diagnosis を完了してください。',
    // ENG-2361 — 第一文を修正（根拠は en のキーに記載）。
    noSurfacesWrap:
      'この部品で利用できる CAD 面がありません。面リストはアップロード後にバックグラウンドで作成されますが、大きすぎる、または複雑すぎる部品では完了しないことがあります。名前はメッシュ作成時にラップ表面へ適用されるため、メッシュを作成してから、メッシュ結果でどの名前が適用され、どの名前が失敗したかを確認してください。',
    // ENG-2361 — 根拠は en のキーに記載。
    wrapDescriptorsPending:
      'この部品の CAD 面を確認しています。アップロード後にバックグラウンドで実行され、通常は1分以内に完了します。準備ができ次第、ここにリストが表示されます。',
    surfaceNumberingMismatch:
      '取得した表面リストの面番号がこの部品と一致しないため、ラベルが誤った面に付くのを防ぐ目的でラベル付けを無効にしています。「再検出」でリストを再構築してください。',
    reDetecting: '再検出中…',
    loading: '読み込み中…',
    reDetect: '再検出',
    reDetectFailed: '表面を再検出できませんでした。もう一度お試しください。',
    noPatchesStl:
      'この STL には割り当て可能な名前付きサーフェスがありません（バイナリまたは単一ソリッドの STL には含まれません）。メッシュ生成は可能で、境界条件はサーフェス全体に適用されます。個別のパッチを割り当てるには、名前付きソリッドを持つ ASCII STL として再エクスポートしてください。',
    seedPointTitle: 'シードポイント（任意）',
    seedPointHide: 'シードマーカーを非表示',
    seedPointShow: 'シードマーカーを表示',
    seedPointHelper:
      '流体キャビティ内部の点（モデル座標、mm）。単純な形状では自動検出されます。キャビティが非凸で自動検出が流体の外に外れる場合に指定してください。ビューアーの琥珀色の点が位置を示します。',
    seedPointAuto: '自動',
    seedPointUseCenter: '部品の中心を使用',
  },
  // The four guarded cavity steps in Boundary Assignment on the wrap path (ENG-2465).
  // Copy is the design handoff's copy sheet (Boundary Assignment Wireframes, 3b).
  cavitySteps: {
    // shell — step titles and shared words (ENG-2465)
    detect: '開口を探す',
    nameOpenings: '各開口に名前を付ける',
    nameZones: '壁面エリアに名前を付ける',
    carve: '流体領域を切り出す',
    carveCoolant: '冷却材を切り出す',
    optional: '任意',
    // openings — step 2 copy (ENG-2466 appends here)
    // zones — step 3 copy (ENG-2430 appends here)
    zoneNameFor: '面 {{face}} の名前',
    wasDetectedOpening: '検出された開口部でした',
    // gates — step status, locked reasons and summaries (ENG-2465 PR 2)
    scanning: 'パーツをスキャン中…',
    detectDone_one: '{{count}} 個の開口を検出',
    detectDone_other: '{{count}} 個の開口を検出',
    skipped_one: '{{count}} 個をスキップ',
    skipped_other: '{{count}} 個をスキップ',
    namedCount_one: '{{count}} 個に命名',
    namedCount_other: '{{count}} 個に命名',
    openingsNoneNamed: '未命名 — 空欄は自動で埋められます',
    lockedNeedsDetect: 'まず開口を探してください。',
    lockedNeedsOpenings: 'まず開口に名前を付けてください。',
    lockedUnmatched_one:
      '適用されなくなった保存済みの名前 {{count}} 件を先にクリアしてください。',
    lockedUnmatched_other:
      '適用されなくなった保存済みの名前 {{count}} 件を先にクリアしてください。',
    lockedNeedsSteps: 'まずステップ 1〜3 を完了してください。',
    lockedNeedsStepsBeforeCoolant: 'まずステップ 1〜2 を完了してください。',
    lockedNamesFirst: '適用されなくなった名前を先にクリアしてください。',
    setGap: 'まず最も狭い隙間を設定してください。',
    carveDone: '流体領域を切り出し済み',
    coolantCarveDone: '冷却材を切り出し済み',
    detectAgain: '再検出',
  },
  blCoverage: {
    suggestedFix: '推奨される修正',
    noActionableChanges: '実行可能な変更はありません。',
    applied: '適用済み',
    applyFix: '修正を適用',
    gateRelaxed: '品質ゲートを緩和 — カバレッジを優先',
    gateDefault: '既定の品質ゲート',
    coverage: 'カバレッジ',
    coverageWeightedWorst: '加重 {{weighted}}·最悪 {{worst}}',
    nearWallAspect: '壁近傍アスペクト比',
    nearWallAspectTooltip:
      'snappy が境界層領域で実際に押し出したセルのアスペクト比です。約 10:1 が健全で、30:1 以上はカバレッジが強制されたことを意味します。',
    aspectMax: '最大 {{max}}',
    aspectMaxP95: '最大 {{max}}·p95 {{p95}}',
    negVolCells: 'BL 領域内の負体積セル',
    extrudedNothing_one:
      '{{count}} 個の patch が何も押し出しませんでした：{{patches}}',
    extrudedNothing_other:
      '{{count}} 個の patch が何も押し出しませんでした：{{patches}}',
    appliedTooltip:
      '推奨される上書き設定を適用しました。効果を確認するにはメッシュを再送信してください。',
    applyTooltip:
      '推奨される上書き設定を適用します。右クリックで前後のプレビューを表示します。',
    noLayersExtruded:
      '境界層が要求されましたが、いずれも押し出されませんでした — どの wall patch にも層が生成されませんでした（通常はセルサイズが粗すぎるか、面が扱いにくいため）。メッシュはインフレーションなしでも使用できます。カバレッジを回復するには最小要素サイズを小さくするか、ジオメトリを修復してください。',
    patchCount_one: '{{count}} 個の patch',
    patchCount_other: '{{count}} 個の patch',
    layerYield: '層歩留まり {{pct}}%',
    allApplied: 'すべて適用済み',
    applyN_one: '{{count}} 件の修正を適用',
    applyN_other: '{{count}} 件の修正を適用',
    allAppliedTooltip:
      'すべての推奨上書き設定を適用しました。効果を確認するにはメッシュを再送信してください。',
    applyNTooltip_one:
      '{{count}} 個の patch に推奨される上書き設定を適用します。累積防止：各差分は同じ基準にアンカーされます。',
    applyNTooltip_other:
      '{{count}} 個の patch に推奨される上書き設定を適用します。累積防止：各差分は同じ基準にアンカーされます。',
    noiseBanner:
      '{{total}} 個の wall patch のうち {{zeroCount}} 個がカバレッジ 0 を示しています — その多くは自動的に失敗する小さな CAD 特徴（フィレット、エッジ）と思われます。重要な patch に対象を絞るため、境界層パネルで特定の面をタグ付けすることを検討してください。',
    hoverNeedsTags:
      'ホバーには面ごとのタグが必要です。境界層パネルを開き、表面をクリックしてタグ付けしてから再メッシュ化してください。',
    hoverUnavailable:
      'このメッシュではホバーを利用できません。有効にするには再メッシュ化してください。',
    layersCount: '{{achieved}}/{{target}} 層',
  },
  boundaryLayer: {
    title: '境界層',
    preview: 'プレビュー',
    presetNone: 'なし',
    presetNoneTitle:
      'BL の押し出しを完全に無効化します — addLayers ステージなしで hex メッシュを確認したいときに便利です。',
    presetStandard: '標準',
    presetStandardTitle:
      '一般的な CFD 向けの 3 層既定。おおまかな BL 効果を捕捉し、メッシュ化が速いです。ソルバーでは壁関数と併用してください。',
    presetResolved: '解像',
    presetResolvedTitle:
      'LES / 低 Re RANS 向けの壁面解像（Y⁺ ≈ 1）。薄い層が多く、メッシュ化と求解は遅いですが、壁面せん断が正確です。',
    diagnosisInProgress: 'Diagnosis 実行中',
    diagnosisInProgressBody:
      '面選択用の STL プレビューは Diagnosis 完了後に利用可能になります。それまでは、クリックしても wall グループを追加できません。',
    pickingOnCavity: 'キャビティ表面で選択中',
    pickingOnCavityBody:
      '内部流モードでは、ボディではなく抽出された流体キャビティ上の面を選択します。キャップ面（inlet/outlet）は個別に選択できます。',
    cavityNotRendered: 'キャビティ STL は未描画です',
    cavityNotRenderedBody:
      'キャビティ STL はまだビューアに描画されていません（読み込み中、または取得/解析に失敗）。現在の選択はボディ STL に対して解決されます。バックエンドは送信時にそれをキャビティ面へ変換しますが、曖昧な一致は破棄される場合があります。キャビティの描画を待つか、そのまま選択して変換リスクを受け入れてください。',
    picksCleared: '以前の wall 選択をクリアしました',
    picksClearedBody:
      'wall グループは以前の表面ソースの面インデックスを参照しています。続行するには現在の表面で面を再タグ付けしてください。',
    dismissNotice: '通知を閉じる',
    noFluidCavity: '流体空洞がまだありません',
    noFluidCavityBody:
      '境界層は空洞の壁面に成長しますが、このパートからはまだ流体空洞が抽出されていません。Mesh Settings で Extract を実行するか、外部流に切り替えてください。',
    layersGrowInward: '層は流体内部へ向かって成長します',
    layersGrowInwardBody:
      '流体は CAD 内でモデル化されているため、プリズム層は壁面/障害物表面から周囲の流体へ押し出されます — 抽出されたキャビティと同じ内向き方向で、外部流のような外向きではありません。',
    description:
      'CFD で境界層を正確に解像するための、壁面近傍のプリズム層です。',
    sectionLabel: '境界層',
    on: 'オン',
    off: 'オフ',
    wallGroupsSelected:
      'プリズム層インフレーション用に選択された wall グループです。',
    groupsShort: '{{count}} グループ',
    triShort: '{{value}} 三角',
    areaShort: '{{value}} 面積',
    layerInputModeTooltip:
      '第 1 セル高さ（y₀）を設定する 2 つの方法です。既定：y₀、層数、成長比を入力します。\nY+ 計算：目標 y⁺（第 1 セルが壁からどれだけ離れているか）と流速、長さ、流体から求め、乱流モデルが必要とする範囲をカバーします。\ny⁺≈1 で壁を解像、30~300 で壁関数用です。',
    layerInputMode: '層入力モード',
    yPlusCompute: 'Y+ 計算',
    defaults: '既定',
    globalDefaults: 'グローバル既定',
    firstCellHeight: '第 1 セル高さ y₀',
    firstCellHeightYPlusTitle:
      '下の y+ 計算機によって駆動されます — 直接編集するには y+ スイッチをオフにしてください。単位セレクタは引き続き使え、計算機の読み値と共有されます。',
    firstCellHeightTitle:
      'プリズムスタックの第 1 セルの壁面法線高さです。表示単位に関わらず、送信値は mm です。-1 または「auto」を入力すると、ソルバーが自動で決定します。',
    autoInitialHeight: 'auto',
    layerCount: '層数 N',
    growthRatio: '成長比 r',
    totalThickness: '総厚さ',
    fluidDensity: '流体密度',
    fluidPresetTooltip:
      'y+ 計算の基準流体です。Air と Water は 20 °C / 1 atm の動粘度を使用します。Custom ρ では ν を直接入力できます。',
    customDensityLabel: 'Custom ρ',
    customNuTitle:
      '動粘度 ν = μ/ρ。20 °C で空気 ≈ 1.5e-5 m²/s、水 ≈ 1.0e-6 m²/s。',
    yPlusTarget: 'y+ 目標',
    yPlusTargetPlaceholder: '例：1',
    yPlusTargetTitle:
      '第 1 メッシュ層が壁からどれだけ近いか — y⁺ は無次元の壁距離です（エネルギー項ではありません）。境界層を直接解像するには ≈1（低 Re RANS / LES）、壁関数に頼る場合は 30~300 を使用します。下で設定した流速、長さ、流体を使って y⁺ を第 1 セル高さに変換します。',
    velocity: '速度 U∞',
    velocityPlaceholder: '例：10',
    velocityTitle:
      '外部流では自由流速度、内部流ではバルク速度です。Re = U·L/ν を決定します。',
    charLength: '代表長さ L',
    along: '軸：',
    charLengthAxisInternalTooltip:
      '内部流 — 水力次元を表す軸を選択してください',
    charLengthAxisTooltip: 'L の元となる CAD 境界を選択してください',
    charLengthTitle:
      'Re の代表長さです。既定では選択した軸（X / Y / Z）方向の CAD バウンディングボックスになります。値を入力すると上書きできます。単位はエンクロージャパネルと共有されます。',
    totalThicknessReadout: '総厚さ =',
    layerCountReadout: '層数 N =',
    laminarWarning:
      'Re < {{threshold}} — 流れは層流です。ここで使用している Cf 相関式は乱流用のため y₀ は不正確な場合があります。この Re で壁面解像 BL が必要かどうかを検討してください。',
    transitionWarning:
      '遷移域の Re — Cf 相関式の精度が低下します。y₀ は推定値として扱ってください。',
    advancedAddLayers: '詳細（snappy addLayers）',
    readOutLengthUnit: '読み値の長さ単位',
    carvedWallLayers: '抽出された壁の境界層',
    wallGroups: 'Wall グループ',
    deleteSelected: '選択項目を削除',
    globalActive: 'グローバル BL 有効 — すべてのグループがグローバル既定を使用',
    globalPopulate: 'すべてのジオメトリ面を追加し、グローバル既定を一律に適用',
    global: 'グローバル',
    selectAll: 'すべて選択',
    selectAllTooltip: 'すべて選択（Ctrl+A）',
    addFromViewer: 'ビューアで表面をクリックするとここに追加されます。',
    confirmRemove: 'クリックして削除を確認',
    clickToSelect: 'クリックして選択',
    clickToRename: 'クリックして名前を変更',
    // 「三角面」= STL テッセレーションのファセット. 「三角」だけだと
    // 幾何学名詞と紛らわしいので「面」を添え、メッシュ化文脈で
    // ある事を明示 (各 face は複数の三角面で離散化される).
    triCount: '{{value}} 三角面',
    // 「面積」は字面のまま; グループ行のカラム位置で意味は自明.
    areaCount: '面積 {{value}}',
    clickAgainToRemove: 'もう一度クリックで削除',
    globalRow: 'グローバル',
    applyAndBack: '適用してメッシュに戻る',
    unitLabel: '単位',
    regimeLaminar: '層流',
    regimeTransition: '遷移',
    regimeTurbulent: '乱流',
  },
  embeddedFluid: {
    roleFluid: '流体',
    roleWall: '壁面',
    roleExclude: '除外',
    roleFluidHint:
      '流れ領域の一部です。少なくとも 1 つのボディを流体にする必要があります。',
    roleWallHint:
      '流れの中の障害物 — その表面は流体のノースリップ壁面になります。',
    roleExcludeHint:
      'ボディを完全に除去します。流れに接触しない部品（ファスナーなど）のみに使用します。流体と表面を共有する場合は「壁面」を使用してください。',
    internalFlowStyle: '内部流の方式',
    singleBodyHint:
      'このパーツはボディが 1 つのため分類対象がありません。埋め込み流体には複数ボディのアセンブリ（流体ボディ + 固体障害物）が必要です。流体抽出はキャビティを自動的に導出します。',
    fluidExtraction: '流体抽出',
    embeddedFluid: '埋め込み流体',
    stlUnsupported:
      '埋め込み流体には複数ボディのソリッド CAD（STEP/BREP）が必要です。STL は非対応です。流体抽出を使うか、STEP で再アップロードしてください。',
    embeddedDescription:
      '流体は CAD 内でモデル化されています。下で各ボディを流体または壁面障害物に分類してください。障害物はノースリップ壁面になります。',
    extractionDescription:
      '流体キャビティは閉じた固体から抽出されます。下で inlet/outlet 面をタグ付けしてください。',
    bodies: 'ボディ（{{count}}）',
    markOneFluid:
      '少なくとも 1 つのボディを流体としてマークしてください — 流れには領域が必要です。',
    bodyLabel: 'ボディ {{index}}',
  },
  enclosure: {
    hideEnclosure: 'エンクロージャを非表示',
    showEnclosure: 'エンクロージャを表示',
    enclosure: 'エンクロージャ',
    openGeometry_one:
      '開放ジオメトリ（境界エッジ {{count}} 本）。領域の配置が不安定になる可能性があります。内部流（ダクト、ハウジング）の場合は、すべての係数を 0 に設定してください。',
    openGeometry_other:
      '開放ジオメトリ（境界エッジ {{count}} 本）。領域の配置が不安定になる可能性があります。内部流（ダクト、ハウジング）の場合は、すべての係数を 0 に設定してください。',
    displayInTooltip:
      '{{unit}} で表示中（CAD ソース：{{source}}）。右クリックで変更。',
    unitsInferredTooltip:
      '単位は STEP ファイルヘッダーから推定されました（{{unit}}）。右クリックで表示単位を変更。',
    noUnitTooltip:
      'STEP ヘッダーに単位が見つかりません — 右クリックで表示単位を設定。',
    displayUnits: '表示単位',
    fromCad: 'CAD から',
    unknownUnit: '不明',
    unitPlaceholder: '単位？',
    // 「上流/下流/側方」— 外部流の風洞語境:
    //  · 上流 (Upstream)   = inlet 側, 流体の入り口
    //  · 下流 (Downstream) = outlet 側, 流体の出口
    //  · 側方 (Lateral)    = 流れに直交する両側の側面 (通常は壁面)
    roleUpstream: '上流',
    roleDownstream: '下流',
    roleLateral: '側方',
  },
  snappyFields: {
    // snappyHexMesh のメッシュ品質 / addLayers 境界層押し出しパラメータの
    // ラベルと説明. 学術/CFD 慣用訳; FV / BL などの英字略語は
    // 技術文献での慣例に従いそのまま.
    rangeSuffix:
      'デフォルト: {{default}} · 厳しい {{strict}} / 緩い {{permissive}}',
    // 「非直交角」= 隣接セル中心線と共有面法線の成す角度 (度)
    maxNonOrthoLabel: '最大非直交角',
    maxNonOrthoDesc:
      '面の最大非直交角 (°). 大きいほど許容セル数が増え、ソルバ精度は下がる. 信頼性の主な調整ノブ.',
    // 「歪度/スキューネス」の日本語慣例
    maxInternalSkewLabel: '最大内部面歪度',
    maxInternalSkewDesc: '内部面の最大歪度. これを超えるセルは棄却される.',
    maxBoundarySkewLabel: '最大境界面歪度',
    maxBoundarySkewDesc:
      '境界 (壁面) 面の最大歪度. 壁面セルは大きめの歪度を許容する.',
    // 「凹角」セルの最大凹み角
    maxConcaveLabel: '最大凹角',
    maxConcaveDesc: 'セルの最大凹み角 (°).',
    minVolRatioLabel: '最小体積比',
    minVolRatioDesc:
      '隣接セル間の最小体積比. 低いほど急激なサイズ変化を許容する.',
    // 「面の重み係数」= 有限体積 (Finite Volume) の内挿重み
    minFaceWeightLabel: '最小面重み係数',
    minFaceWeightDesc: '最小内挿重み — 有限体積スキームの精度に影響する.',
    // face twist = 面のねじれ度
    minTwistLabel: '最小面ねじれ度',
    minTwistDesc: '面の最小ねじれ度.',
    // determinant = 変換行列式, 退化セルのフィルタ
    minDeterminantLabel: '最小行列式値',
    minDeterminantDesc: 'セルの最小行列式値 (退化に近いセルをフィルタ).',
    relaxedMaxNonOrthoLabel: '緩和版最大非直交角',
    relaxedMaxNonOrthoDesc:
      '主閾値が失敗した時のフォールバック上限 — snappy はこの緩めた境界で再試行する.',
    // 「レイヤー厚比」/「メディアル軸 (中心軸)」
    maxFaceThicknessRatioLabel: '最大レイヤー厚比',
    maxFaceThicknessRatioDesc:
      '境界層押し出し中の、レイヤー厚と隣接面厚の最大比. 大きいほど面厚の変化する曲面にも境界層が乗る.',
    maxThicknessToMedialLabel: '厚さ/メディアル軸比の上限',
    maxThicknessToMedialDesc: 'レイヤー厚と局所メディアル軸距離の最大比.',
    minMedialAxisAngleLabel: '最小メディアル軸角',
    minMedialAxisAngleDesc:
      'メディアル軸角がこの値 (度) を下回ると、snappy は狭すぎると判断して押し出しを拒否する.',
    // n_layer_iter = addLayers の外側反復回数
    nLayerIterLabel: 'レイヤー反復回数',
    nLayerIterDesc:
      'addLayers の「押し出し → 品質チェック → 緩和 → 再試行」の最大外側反復回数.',
    nRelaxedIterLabel: '緩和反復回数',
    nRelaxedIterDesc:
      'addLayers が緩和メッシュ品質制約に切り替わった後のサブ反復回数.',
  },
  engineOverrides: {
    beta: 'Beta',
    snapToFeatureEdges: 'CAD 特徴エッジにスナップ',
    snapToFeatureEdgesHelper:
      'メッシュ化時にメッシュ頂点を CAD 特徴曲線に直接引き寄せます — ほとんどのジオメトリで、よりシャープでクリーンなエッジになります。',
    polishSnappedEdges: 'スナップ済みエッジを研磨',
    polishSnappedEdgesHelper:
      'スナップ後、残った近エッジの頂点を CAD 曲線に寄せ、ギザギザのエッジを滑らかにします。「CAD 特徴エッジにスナップ」をオンにすると最も効果的です。',
    engineOverrides: 'エンジン上書き',
    presetFast: '高速',
    presetFastTitle:
      '壁近傍が粗く、一般的なジオメトリで約 30 秒でメッシュ化。初回検証や境界条件のデバッグ用 — 物理は不正確になります。',
    presetStandard: '標準',
    presetStandardTitle:
      '典型的な CAD 向けのケース実証ベースライン（feature_angle 120°、n_smooth_patch 5、snap 反復 100/10）。細分化レベルは Auto のまま — バックエンドがジオメトリの複雑さに応じて制限します。',
    presetFine: '精細',
    presetFineTitle:
      'シャープな特徴の量産 CFD — セル数が 5~10 倍。ブレード、フィン、シャープな前縁など壁近傍の精度が重要な箇所に使用します。',
    refineInverted:
      'Refine Level Min（{{min}}）> Refine Level Max（{{max}}）。バックエンドはこれを拒否します — 入れ替えてください。',
    refineMaxHigh:
      'Refine Level Max {{max}} ≈ {{factor}}× 壁面セル — 大規模な L6+ メッシュは数十分かかり、既定の 30 分の戦略タイムアウトを超える場合があります。メッシュ化が遅い場合は戦略タイムアウトを引き上げてください。',
    snapFidelity: 'Snap 忠実度',
    edgeRecoveryTip:
      'ヒント：最もクリーンな結果には「スナップ済みエッジを研磨」もオンにしてください。',
    snappyQuality: 'Snappy 品質',
    presetAdvanced: '詳細',
    presetAdvancedTitle:
      'すべての受理しきい値を厳しくします — 研究グレード。CAD がクリーンなときにソルバー精度が最良になりますが、メッシャーがより多くのセルを拒否する場合があります。既知の良好なケースがある場合のみここから始めてください。',
    presetRelaxed: '緩和',
    presetRelaxedTitle:
      '受理しきい値を緩めます — 曲面やシャープなジオメトリでメッシュ化が繰り返し失敗する場合に便利です。メッシュは完了しますが、ソルバー精度は低下する可能性があります。',
    presetReset: 'リセット',
    presetResetTitle:
      'すべての snappy 品質 + addLayers ノブを Auto にリセットします。バックエンドは経験的に検証されたバランスの取れた既定値を使用します。',
    cellBudget: 'セル予算',
    cellBudgetHint:
      'L4 を超える細分化レベルごとに既定値が 2 倍になります。値を固定すると上書きできます。',
    addLayers: 'Add Layers',
    prioritizeBlCoverage: 'BL カバレッジを優先',
    prioritizeBlCoverageHelper:
      '境界層カバレッジを増やすため、品質が低下した（ただし有効な）セルを許容します。層ゲートを緩める検証済みの方法です — Snappy 品質の「緩和」プリセットよりこちらを優先してください。既定はオフ。',
    advancedOverrides: '詳細な上書き',
    bypassDirtyCad: '汚れた CAD の事前チェックゲートをバイパス',
    bypassDirtyCadHelper:
      '自己交差や非水密のジオメトリを、最初にブロックせずメッシュ化まで通します。既定はオンで、実行は常にメッシュ化を試みます。事前チェックゲートを再び有効にして汚れた CAD をメッシャーの時間を浪費する前にブロックするには、チェックを外してください。',
    fieldSmoothing: 'スムージング',
    fieldAlgorithm2d: '2D アルゴリズム',
    fieldAlgorithm3d: '3D アルゴリズム',
    fieldGrading: 'グレーディング',
    fieldOptPasses: '最適化パス',
    fieldCurvatureSafety: '曲率安全率',
    fieldSegmentsPerEdge: 'エッジあたりセグメント数',
    fieldRefineLevelMin: '最小細分化レベル',
    fieldRefineLevelMax: '最大細分化レベル',
    fieldFeatureAngle: '特徴角度',
    fieldCellsBetweenLevels: 'レベル間セル数',
    fieldResolveFeatureAngle: '特徴角度の解像',
    fieldSmoothPatch: 'スムーズ patch',
    fieldBlockmeshCellSize: 'BlockMesh セルサイズ',
    fieldSnapSolveIter: 'Snap ソルブ反復',
    fieldFeatureSnapIter: '特徴 snap 反復',
    fieldSnapTolerance: 'Snap 許容差',
    fieldMeshSizeFine: 'メッシュサイズ（細）',
    fieldMeshSizeCoarse: 'メッシュサイズ（粗）',
    fieldMeshSizeFarfield: 'メッシュサイズ（遠方場）',
    fieldMaxLocalCells: 'ローカル最大セル数',
    fieldMaxGlobalCells: 'グローバル最大セル数',
    tipSmoothing:
      'メッシュ化後に適用するラプラシアン平滑化のパス数。要素品質が向上します。多いほど滑らかですが遅くなります。既定：Auto。',
    tipAlgorithm2d:
      'Gmsh の 2D 表面メッシュ化アルゴリズム（数値コード — 例：6 = Frontal-Delaunay）。この部品で表面メッシュ化がうまくいかない場合以外は Auto のままにしてください。',
    tipAlgorithm3d:
      'Gmsh の 3D 体積メッシュ化アルゴリズム（数値コード — 例：10 = HXT、高速な並列 Delaunay）。既定：Auto。',
    tipGrading:
      '要素サイズが細から粗へどれだけ速く成長するか。1.0 付近はほぼ均一、大きいほど速く粗くなりセル数が減ります。既定：Auto。',
    tipOptPasses:
      'メッシュ化後の最適化パス。品質の悪い四面体を解きほぐして改善します。パスが多いほど品質は上がりますがメッシュ化は遅くなります。既定：Auto。',
    tipCurvatureSafety:
      '曲面をどれだけ積極的に細分化するか — 大きいほど小さな要素で曲率を解像します（セル数が増加）。既定：Auto。',
    tipSegmentsPerEdge:
      '各 CAD エッジに沿った最小メッシュ分割数。短いエッジや小さな特徴を解像するには上げてください。既定：Auto。',
    tipRefineLevelMin:
      'ボディ上の最小表面細分化レベル。+1 ごとに局所的に壁面セルサイズが半分になります。既定：Auto（min_size から）。2~3 を試してください。',
    tipRefineLevelMax:
      '最大表面細分化。+1 ごとにその領域のセル数が約 8 倍になります。壁近傍のディテールを制御する主要ノブです。既定：Auto（min_size から）。4~6 を試してください。',
    tipFeatureAngle:
      '二面角（°）。この値未満のエッジはシャープな特徴として扱われ、追加で細分化されます。低いほど多くのエッジが捕捉されます。既定：150°。30°（シャープ）、60°（緩やか）を試してください。',
    tipCellsBetweenLevels:
      '細分化レベル間の遷移域のバッファセル数。多いほどグレーディングが滑らかになり、歪んだセルが減ります。既定：3。3~5 を試してください。',
    tipResolveFeatureAngle:
      'メッシュを検出した特徴にロックする snap 段階の角度しきい値（°）。低いほどコーナーへのスナップが積極的になります。既定：30°。15~30° を試してください。',
    tipSmoothPatch:
      'スナップ後の表面メッシュのスムージング反復回数。多いほど patch が滑らかになりますが遅くなります。既定：3。3~5 を試してください。',
    tipBlockmeshCellSize:
      '背景 hex のエッジ長（mm）。細分化前のベースを設定し、その他はすべてこれに相対します。既定：Auto（約ボディ/30）。ボディ長の 5~10% を試してください。',
    tipSnapSolveIter:
      'snap 段階中のソルバー反復回数。多いほど壁面適合が良くなりますが遅くなります。既定：30。30~50 を試してください。',
    tipFeatureSnapIter:
      'メッシュを特徴エッジにスナップするための専用反復回数。既定：5。シャープなジオメトリでは 5~10 を試してください。',
    tipSnapTolerance:
      'snap 変位許容差（× セルサイズ）。低いほどスナップが厳しく（反転セルのリスク増）、高いほど緩く（表面適合が悪化）なります。既定：2.0。1.0~5.0 を試してください。',
    tipMeshSizeFine:
      '壁面 STL の三角サイズ（mm）。メッシャーがさらに細分化する前の入力表面の細かさを設定します。既定：½ × min_size。',
    tipMeshSizeCoarse:
      '特徴から離れた場所の STL 三角サイズ（mm）。既定：2× 細。2~5× 細を試してください。',
    tipMeshSizeFarfield:
      'エンクロージャボックス上の三角サイズであり、計算領域全体の背景セルサイズでもあります（mm）。総セル数への影響が最も大きいため、細かくするのではなく粗くしてください。既定：Auto（約 body/7）。',
    tipMaxLocalCells:
      '細分化中に各並列ワーカーが保持する最大セル数。既定値は Refine Level Max（L{{level}}）に応じて {{value}} にスケールします。値を固定すると上書きできます。',
    tipMaxGlobalCells:
      '細分化中の総セル数の上限。既定値は Refine Level Max（L{{level}}）に応じて {{value}} にスケールします。高細分化の L6 ファンは ≥ 16M が必要な場合があります。値を固定すると上書きできます。',
    autoDerivedSize:
      '自動の場合、ここは約 {{value}} mm に決まります。メッシャーが形状に合わせて調整する場合があります。',
    autoDerivedLevel:
      '自動の場合、ここはメッシュサイズをもとに約レベル {{value}} に決まります。メッシャーが形状に合わせて調整する場合があります。',
  },
  generatingMesh: {
    generatingMesh: 'メッシュを生成中',
  },
  meshExport: {
    export: 'エクスポート',
  },
  refinement: {
    localRefinement: '適応細分化',
    sicnThreshold: 'SICN しきい値（これ未満の要素を細分化）',
    targetSize: '目標サイズ（mm、任意）',
    submitting: '送信中…',
    refineMesh: 'メッシュを細分化',
    failedToSubmit: '送信に失敗しました',
  },
  refinementZones: {
    title: 'ローカル細分化',
    stepSummary_one: '{{count}} ゾーン',
    stepSummary_other: '{{count}} ゾーン',
    entryHint: 'ビューアに配置したボックス内のメッシュを細かくします',
    hexOnly: 'Hex または Poly メッシュ専用',
    description:
      '細かいセルが必要な場所（狭い流路、後流、ジェットなど）にボックスを配置します。各ゾーン内のセルは目標サイズまで細分化され、それ以外は粗いままです。',
    zonesHeader: 'ゾーン',
    addBox: 'ボックスを追加',
    addSphere: '球を追加',
    addWaitingForModel: 'モデルの読み込みを待っています…',
    empty: 'ゾーンはまだありません。ボックスを追加して領域を細分化します。',
    zoneSummaryBox: 'ボックス · {{dims}} mm',
    zoneSummarySphere: '球 · r={{radius}} mm',
    showInViewer: 'ビューアに表示',
    hideInViewer: 'ビューアで非表示',
    hiddenStillApplies:
      'ビューアでは非表示ですが、メッシュ生成時には適用されます。',
    renderBudgetExceeded:
      'ゾーンが多すぎてすべては表示できませんが、余分なゾーンもメッシュ生成時には適用されます。',
    deleteZone: 'ゾーンを削除',
    renameZone: 'ゾーン名',
    boxDefinition: 'ボックス定義',
    sphereDefinition: '球の定義',
    modeCenterSize: '中心＋サイズ',
    modeMinMax: '最小 / 最大',
    centerMm: '中心（mm）',
    sizeMm: 'サイズ（mm）',
    minPointMm: '最小コーナー（mm）',
    maxPointMm: '最大コーナー（mm）',
    radiusMm: '半径（mm）',
    targetCellSize: '目標セルサイズ',
    centerTip: 'モデル座標系におけるボックスの位置です。',
    sizeTip: '各軸方向のボックスの大きさです。',
    minPointTip: 'X・Y・Z が最小のコーナー。ビューアでは琥珀色で表示されます。',
    maxPointTip: 'X・Y・Z が最大のコーナー。ビューアではシアンで表示されます。',
    radiusTip: '中心から球が広がる距離です。',
    targetCellSizeTip:
      'このゾーン内で狙うセルサイズです。最も近い細分化レベルにスナップします。',
    refinementLevel: '細分化レベル',
    refinementLevelTip:
      '各レベルで背景セル（{{blockmesh}} mm）が半分になり、セルは 2 のべき乗で細かくなります。目標値は最も近いレベルにスナップします。レベルをクリックすると、そのセルサイズが目標値になります。',
    effectiveOk: 'レベル {{level}} で実効サイズ {{size}} mm',
    cappedTitle: 'レベル {{level}} では目標に届きません',
    cappedDetail:
      '{{target}} mm を指定しましたが、最大細分化レベル（{{level}}）では {{effective}} mm までしか細かくできません。レベルを上げると目標に届きます。',
    raiseLevel: '最大細分化レベルを {{level}} に上げる',
    beyondMaxLevel:
      '{{target}} mm の目標にはレベル {{level}} が必要で、最大値 8 を超えています。目標を粗くしてください。',
    coarserThanBase:
      '目標が背景セル（{{blockmesh}} mm）より粗いため、このゾーンでは細分化されません。',
    sizesUnknown:
      'セルサイズのプレビューにはジオメトリ境界が必要です。まず診断を実行してください。',
    approxNote:
      'サイズは概算です。メッシャーがセル数の上限に合わせて調整する場合があります。',
    presets: 'プリセット',
    fitToDomain: '領域全体に合わせる',
    fitToFaceHint:
      'クリックすると、選択中のゾーンがその面を囲むように合わせられます。',
    done: '完了',
    cancel: 'キャンセル',
  },
  meshSource: {
    label: 'メッシュ対象',
    fluidDomain: '流体領域',
    body: 'ボディ',
    tip: '表示・選択・メッシュ生成の対象となる面。流体領域＝抽出したキャビティ。ボディ＝CAD 表面（アップロードが既に流体そのものの場合に使用）。',
  },
  overrideInput: {
    auto: 'Auto',
  },
  qualityTarget: {
    qualityTarget: '品質目標',
    off: 'オフ',
    offTitle: 'メッシュ後の品質ゲートなし',
    // 「緩め/標準/厳しめ」— 直訳の「ルーズ/タイト」は日常語過ぎる
    // ので、CFD 現場で通じる形容詞を採用.
    presetLoose: '緩め',
    presetStandard: '標準',
    presetTight: '厳しめ',
    // SICN (Signed Inverse Condition Number) は英字略語のまま.
    tetLabel: 'SICN 最小値',
    tetHint:
      '数値が大きいほど厳しい (0~1)。最悪要素の SICN が目標に達するまで平滑化パスを追加します。',
    tetDescription:
      'メッシュ後の品質ゲート。四面体オプティマイザが最小 SICN が目標を満たすまで追加の平滑化パスを実行します。',
    // 「非直交角」= 隣接セル中心線と共有面法線の成す角度. 学術慣例
    // に従い「最大非直交角」で統一.
    hexLabel: '最大非直交角 (°)',
    hexHint:
      '数値が小さいほど厳しい (度)。最大非直交角が目標に達するまでメッシュを再生成します。',
    hexDescription:
      'メッシュ後の品質ゲート。最大非直交角が目標を満たすまで snappyHexMesh を厳しい制御で再実行します。',
    polyDescription:
      'メッシュ後の品質ゲート。最大非直交角が目標を満たすまで cfMesh を厳しい制御で再メッシュします。',
  },
  geometryHealth: {
    errorTimeout:
      'ジオメトリが複雑すぎて分析できません。モデルを簡略化するか、小さな特徴を削除してください。',
    errorSegfault:
      'ジオメトリに処理できない特徴が含まれています。破損した表面や重なったボディがないか確認してください。',
    errorOom:
      'ジオメトリが大きすぎて分析できません。ボディ数を減らすか、アセンブリを分割してください。',
    errorAbort:
      'ジオメトリ形式を読み取れませんでした。CAD ツールからファイルを再エクスポートしてください。',
    errorNoResult:
      '分析は完了しましたが、トポロジーデータを抽出できませんでした。ファイルを STEP として再エクスポートしてください。',
    errorZeroVolume:
      'このジオメトリには実体のボリュームがありません — サーフェスボディまたはスケッチの可能性があります。メッシュ化には閉じた固体が必要です。',
    errorNoGeometry:
      'ファイルにジオメトリが見つかりません。ファイルが空か、点や曲線のみか、サポートされていない形式の可能性があります。',
    errorGeneric:
      'Diagnosis に失敗しました。ファイルを再アップロードしてください。',
    errorFallback:
      'ジオメトリを分析できませんでした。CAD ツールで「ジオメトリの修復」を有効にして再エクスポートしてください。',
    dimensionalTooltipWithUnit:
      'Diagnosis 中に検出された元の CAD 単位：{{unit}}。値は mm で表示（OCC の内部作業単位）。',
    dimensionalTooltipNoUnit:
      'CAD ヘッダーに単位が宣言されていません — 値は mm で表示（OCC の内部作業単位）。「Mesh Settings → Units」でソース単位を選択してください。',
    countVol: '{{count}} ボリューム',
    countSurf: '{{count}} サーフェス',
    countCurv: '{{count}} カーブ',
    diagValue: '{{value}} mm 対角',
    surfaceAreaValue: 'SA {{value}} mm²',
    manifold: '多様体',
    watertight: '水密',
    geometryClean: 'ジオメトリはクリーンです',
    noIssuesFound: 'トポロジーや品質の問題は見つかりませんでした',
    blockingTitle: 'ブロッキング · 要修正',
    blockingFootnote:
      'トポロジーエラー — メッシュ化が失敗するか不良セルを生成する可能性があります。CAD の修復を推奨します。',
    qualityTitle: '品質 · 参考',
    qualityFootnote: '通常はより細かいメッシュサイズを選ぶことで対処できます。',
    shownInViewer: 'ビューアに {{shown}}/{{total}} 表示',
    showAll: 'すべて表示',
    noPerIssueDetails: 'このジオメトリには問題ごとの詳細が返されませんでした。',
    showInViewer: 'ビューアに表示',
    hideInViewer: 'ビューアで非表示',
    showLayerInViewer: 'ビューアに {{label}} を表示',
    hideLayerInViewer: 'ビューアで {{label}} を非表示',
    askAi: 'AI に質問',
    askAiTooltip: 'このジオメトリについて AI に質問する',
    uploadToRunDiagnosis: 'ファイルをアップロードして Diagnosis を実行',
    diagnosingGeometry: 'ジオメトリを診断中…',
    detailedIncomplete: '詳細な Diagnosis が未完了です',
    diagnosisFailed: 'Diagnosis に失敗しました',
    detailedIncompleteBody:
      'ヘルスチェックは完了しませんでしたが、ジオメトリプレビューは利用可能で、メッシュ化は続行できます。',
    noDiagnosisAvailable: '利用できる Diagnosis はありません',
    repairingNewVersion: '新しいバージョンを修復中…',
    diagnosingNewVersion: '新しいバージョンを診断中…',
    uploading: 'アップロード中…',
    uploadFixedVersion: '修正版をアップロード',
    title: 'ジオメトリ ヘルス',
  },
  repairHistory: {
    issueManifoldEdge: '非多様体エッジ',
    issueManifoldVertex: '非多様体頂点',
    issueWatertight: '境界のすき間',
    issueWinding: '面の巻き方向の不一致',
    issueZeroLengthEdge: 'ゼロ長エッジ',
    issueSelfIntersection: '自己交差',
    issueOverlappingFace: '重なった面',
    issueDegenerateFace: '退化した面',
    fullyRepaired: '完全に修復',
    partiallyRepaired: '部分的に修復',
    repairFailed: '修復失敗',
    repairNotKept: '採用されず',
    repairAttempted: '修復を試行しました',
    fixed: '{{labels}} を修正',
    removed: '除去: {{items}}',
    diagnosing: '診断中…',
    repairing: '修復中…',
    current: '（現在）',
    viewVersion: 'バージョン {{version}} を表示',
    viewVersionCurrent: 'バージョン {{version}} を表示（現在）',
    downloadVersion: 'バージョン {{version}} のソースファイルをダウンロード',
    downloadTooltip: 'このバージョンのソースファイルをダウンロード',
    title: '修復履歴（{{count}} バージョン）',
    originUpload: 'アップロード',
    originAutoRepair: '自動修復',
    originManualRepair: '修復',
    originManualUpload: '手動アップロード',
    originCadMorph: 'CadMorph',
    failureCadMorphRejected: 'CAD変更を却下',
    originCadSimplify: 'CAD 簡略化',
    failureSimplifyRejected: '簡略化を却下',
    failureRepairFailed: '修復失敗',
    failureDiagnosisFailed: 'Diagnosis 失敗',
  },
  snapFidelity: {
    surfaceDev: '表面偏差（平均 / 最大）',
    surfaceDevHint:
      'メッシュ化した表面が CAD 表面からどれだけ離れているか — 平均と最悪ケースの距離です。小さいほど元のジオメトリへの適合が緊密です。',
    featureCapture: '特徴捕捉（≤ 0.5 セル）',
    featureCaptureHint:
      '真の位置から半セル幅以内に収まった CAD 特徴エッジの割合です。高いほどシャープなエッジが本来の位置にスナップしています。',
    resolvableFeatures: '解像可能な特徴',
    resolvableFeaturesHint:
      '現在のセルサイズで解像できるほど十分に細かい CAD 特徴エッジの割合です。値が低いとメッシュが粗すぎてスナップできません — まず最小要素サイズを小さくしてください。',
    snapConverged: 'Snap 収束',
    snapConvergedHint:
      'メッシャーのエッジスナップ反復が安定したかどうかです。「いいえ」は一部のエッジが CAD 特徴にロックしなかったことを意味します。残った不正な面があれば併せて表示されます。',
  },
  submitButton: {
    blockedTooltip:
      '1 つ以上の設定エラーが送信をブロックしています。上に表示された項目を解決してください。',
    fixValidationErrors: '上の検証エラーを修正してください',
    preparing: '準備中…',
    generateMesh: 'メッシュを生成',
  },
  validation: {
    cellCoarserThanPassage:
      '{{target}} mm 以下にしてください。{{minSize}} mm は流路に対して粗すぎます。',
    chtNeedsCavity:
      'まず冷却液キャビティを抽出してください。共役解析では流体が独立したボディである必要があります。',
    chtNeedsFluidBody: 'ボディ分類で冷却液ボディを流体として指定してください。',
    noFluidCavityWarning:
      'このジオメトリでは流体キャビティが抽出されませんでした（多くは汚れているか未修復のボディ）。信頼できるキャビティメッシュを得るには、ボディを修復して Diagnosis を再実行するか、外部流に切り替えてください。',
    noWrapCavity:
      'この部品からは流路キャビティがまだ切り出されていません。流体抽出ステップを実行してから、メッシュを送信してください。',
    noWrapChtCarve:
      'メッシュ生成の前に冷却材を切り出してください。境界割り当てを開き、開口を探してから切り出します。',
    embeddedNeedsHex:
      '埋め込み流体には hex メッシュが必要です — 四面体の埋め込み流体実行はソルバーに拒否されます。Element Type を Hex に切り替えてください。',
    pickUnit:
      'このジオメトリの単位を選択してください — まだ利用できる CAD 境界がありません。Diagnosis 完了後に上の Units メニューを使用してください。',
    seedPointRequired:
      'STL の内部流メッシュには流体キャビティ内のシードポイントが必要です — STL からは自動で見つけられません。Boundary Assignment で設定してください。',
    chtPassageRequired:
      '内部から冷却される部品をメッシュ化するには、境界割り当てで最小流路幅を入力してください — 開口を探すと自動で入力されます。抽出処理はこれを推測できず、セルより細い流路は封止されてしまいます。',
    flowPassageRequired:
      'この部品から流体キャビティを切り出すため、最小流路幅を入力してください — 抽出処理はこれを推測できず、セルより細い流路は封止されてしまいます。',
    passagePositive: '最小流路幅は 0 mm より大きい値にしてください。',
    partsWillBeNamed: '部品の名前は {{names}} になります。',
    partCheckRunning:
      'このアップロードに個別の部品があるか確認中です。今メッシュ化すると部品は part_0、part_1 などと名付けられます。確認の完了を待ってから自分で名前を付けることもできます。',
    fixPartNames: 'ボディ分類で次の名前を修正してください：{{names}}。',
    blankName: '空の名前',
    estCells: '推定',
    cellsMeshTime: 'セル ·',
    meshTimeSuffix: 'メッシュ時間',
    warningCount_one: '{{count}} 件の警告',
    warningCount_other: '{{count}} 件の警告',
    hintCount_one: '{{count}} 件のヒント',
    hintCount_other: '{{count}} 件のヒント',
    jumpToInput: 'クリックして関連する入力へ移動',
    // メッシュパラメータ送信前のバリデーション表示. error/warning/info
    // の 3 段階. CFD/CAD 用語 (SICN、y+、mesher、addLayers、feature
    // edges) は英語のまま残す — 論文検索の際のキーワードが英語だから.
    refineMinHigherThanMax:
      '細分レベル下限 ({{min}}) が細分レベル上限 ({{max}}) を上回っています。下限を下げるか上限を上げてください。',
    internalFlowEnclosureConflict:
      '「内部流」と「外部エンクロージャ」は同時に有効にできません。エンクロージャをオフにするか、流動タイプを「外部流」に切り替えてください。',
    meshSizeFineTooLarge:
      '壁面 STL の細メッシュサイズ ({{fine}}) は最大サイズ ({{max}}) より小さくしてください。',
    relaxedNonOrthoLowerThanMain:
      '緩和版最大非直交角 ({{relaxed}}) を最大非直交角 ({{main}}) より小さくすることはできません。',
    hexOnlyFirstOrder:
      '六面体メッシュは 1 次要素のみ対応 — 要素次数を 1 に設定してください。',
    externalStlNoTet:
      '外部流れで STL サーフェスをメッシュ化する場合は四面体を使用できません — 要素タイプを Hex または Poly に設定してください。',
    wrapExternalHexOnly:
      '外部流れでラップしたサーフェスをメッシュ化する場合は六面体のみ対応 — 要素タイプを Hex に設定してください。',
    wrapChtHexOnly:
      'ラップした部品の熱流体連成解析は六面体のみ対応 — 要素タイプを Hex に設定してください。',
    repairChtTetOnly:
      '修復した部品の熱流体連成解析は四面体のみ対応 — 要素タイプを Tet に設定してください。',
    refineMaxHigh:
      '細分レベル上限 {{max}} は概ね壁面セル数の {{factor}} 倍を意味します。セル数上限を設定するか、長時間のメッシュ化を覚悟してください。',
    cellsBetweenLevelsLow:
      '細分遷移が急すぎるとセルが歪みます。層間セル数は最低 3 に設定してください。',
    featureAngleLow:
      '特徴角が低すぎると滑らかな曲面が過剰に細分化されます。通常 30~60° の範囲です。',
    maxNonOrthoHigh:
      '80° を超えるとソルバが発散しがち — 最大非直交角は 80 以下に保ってください。',
    relaxedNonOrthoHigh:
      '85° を超えると圧力ソルバが破綻しやすい — この値は 85 以下に保ってください。',
    blGrowthRateHigh:
      '成長比 1.5 超は境界層から主体メッシュへの遷移が急すぎます。',
    blThickStackLowGrowth:
      '厚いレイヤスタック + 低成長比では、壁面と細分化ゾーンの間に収まらない可能性があります — 層数を減らすか、成長比を上げてください。',
    blStackTallerThanMinSize:
      '境界層スタック ({{stack}} mm) が最小サイズ ({{minSize}} mm) より厚い — レイヤが主体メッシュへオーバーフローします。層数を減らす、第一層高さを下げる、または最小サイズを粗くしてください。',
    blStackVsOpeningDiameter:
      '境界層スタック ({{stack}} mm) が最小開口径 ({{diameter}} mm) の 10 % 超 — 対向壁のレイヤが凹角で衝突します。層数または第一層高さを減らしてください。',
    blFirstLayerLargerThanMinSize:
      '第一層高さ ({{height}} mm) が最小サイズ ({{minSize}} mm) より大きい — 各層が周囲のセルより大きく、境界層の解像度がありません。',
    blFirstLayerFarSmallerThanMinSize:
      '第一層高さが最小サイズの 0.1 % 未満 — この差を解像するには非現実的な細分化が必要です。',
    blSingleLayer: 'レイヤ 1 層のみ — 実質的に境界層なしです。',
    blManyLayers:
      '境界層 {{count}} 層は非常に多く — 8 層超は稀にしか必要ありません。',
    blGrowthRateLow:
      '成長比 1.05 未満はほぼ均等厚のレイヤを生みます — 主体セルサイズに到達するには多層必要です。',
    // 日本語には単複区別が無いため、両 key を同一文で埋めて i18next
    // の count 分岐要件を満たす.
    blSliverTargets_one:
      '境界層ターゲット {{count}} 面 ({{labels}}) が表面積 {{threshold}} mm² 未満です。小さすぎてクリーンにメッシュ化できません — メッシャーが落として近傍の境界層を破ります。',
    blSliverTargets_other:
      '境界層ターゲット {{count}} 面 ({{labels}}) が表面積 {{threshold}} mm² 未満です。小さすぎてクリーンにメッシュ化できません — メッシャーが落として近傍の境界層を破ります。',
    maxInternalSkewLow:
      '最大内部面歪度が 3 以下だと、押し出し後に有効な境界層セルが棄却されがち。デフォルトの 4 まで戻すことをお勧めします。',
    refineMaxHighOnDenseCad:
      '{{surfaces}} 面の高密度 CAD で細分レベル上限 5 以上を使うと、多面の低品質セルが発生します。最大細分レベルを 4 に下げてください。',
    cellsBetweenLevelsHighDeepRefine:
      '広い遷移帯 (層間セル数 3 以上) と深い細分 (上限 5 以上) の組合せは低品質セルを増やします。どちらかを下げてください。',
    tightFeatureManySnapIters:
      '狭い特徴角 (≤ 60°) と多い snap 反復 (≥ 15) は頂点を過剰にエッジへ引き寄せます。ミラー面上の境界層が非対称になることがあります。',
    minMedialAxisAngleHigh:
      '最小メディアル軸角が 90° 以上だと、中程度の曲率を持つ壁面 (ターゲット多数) で境界層が棄却されます。30° への引き下げをお勧めします。',
    tetFailsOnDenseCad:
      '四面体メッシュは高密度 CAD (100 面超) + 面別境界層でしばしば失敗し、暗黙に六面体へフォールバックします。最初から要素タイプを六面体に設定してください。',
    blHostileOverridesCombo:
      '境界層に不利な上書きが {{count}} 個同時に設定されています — 低品質セルと境界層失敗のリスクが高い。「エンジン上書き」を「標準」にリセットし、1 つずつ調整してください。',
    sizeRatioHigh:
      '最大サイズが最小サイズの {{ratio}} 倍 — メッシャーが扱いづらい急な尺度ジャンプです。差を縮めるか、長いメッシュ化時間を覚悟してください。',
    sizeRatioLow:
      '最大サイズが最小サイズに近すぎます — 細分化がほとんど効きません。範囲を広げることをお勧めします。',
    blIgnoredNonCfd:
      '境界層は CFD と Wrap CHT に対応しています。このジョブには含まれません。',
    // 「Refinement will auto-derive from Min Size / Max Size — leave
    // overrides on Auto unless you have a specific target.」= ユーザ
    // が最も頻繁に目にする info 行.
    refinementAutoDerives:
      '細分化は「最小サイズ/最大サイズ」から自動導出されます — 特定の目標がない限り、上書きは Auto のままにしてください。',
    allMeshSizesManual:
      'すべてのメッシュサイズ上書きを手動設定 — 最小サイズに基づく自動導出をバイパスします。',
  },
  meshSettings: {
    wrapChtLayerDescription:
      '「自動」はサーバーの既定値に従うため、境界層が生成されない場合があります。すべての流体と固体の接触面に境界層を指定するには「カスタム」を選んでください。',
    partCheckRefused: 'この部品を分離できませんでした。',
    partCheckOneBlock:
      'すべての部品を分離できませんでした。メッシュでは 1 つのソリッドとして扱います。',
    partCheckOutside:
      '外部冷却では、これらの部品を 1 つのソリッドとして解析します。外部冷却での部品分離にはまだ対応していません。',
    partCheckUnavailable:
      'このアップロードの部品分離はまだ確認されていません。',
    partCheckCount: '検出された部品数: {{count}}',
    partCheckNever:
      'このアップロードは個別の部品の確認が行われていません。部品に名前を付けるには、CAD をもう一度アップロードしてください。名前がない場合、部品は part_0、part_1 などと呼ばれます。',
    layersSupportedModes: 'CFD または Wrap CHT のみ',
    blCustom: 'カスタム',
    blAutomatic: '自動',
    feaCoupling: 'アセンブリ界面',
    feaShared: '共有節点 — 接合',
    feaIndependent: '独立部品 — 接触設定用',
    feaCouplingHint:
      '共有節点は連続性を強制します。独立部品には SimOps で明示的な接続設定が必要です。変更には再メッシュが必要で、接触は自動設定されません。',

    // 「メッシュ設定」— UI タイトル. 一般 / 境界 / 境界層 / 詳細等の
    // ステップを内包するコンテナ.
    title: 'メッシュ設定',
    simulation: 'シミュレーション',
    prepProvenanceRepair: '前処理: 修復 · インポート時に設定',
    prepProvenanceWrap: '前処理: ラップ · インポート時に設定',
    comingSoon: '近日公開',
    chtNeedsSolidCad:
      'CHT には、別々のソリッド領域を持つソリッド CAD（STEP/BREP）が必要です。STL は非対応です。CHT を実行するには STEP で再アップロードしてください。',
    wrapChtScope:
      '冷却方式：{{cooling}}（基本設定で選択）。各部品の役割は Wrap が自動で設定します。',
    chtCooling: '冷却方式',
    chtCoolingOutside: '外側から',
    chtCoolingInternal: '内部の流路',
    chtCoolingOutsideTooltip:
      '部品は周囲の流体で冷却されます — 空気中のヒートシンクや、風が当たる筐体などです。部品は 1 つのソリッドとなり、その周囲の囲み領域の内側すべてが流体になります。',
    chtCoolingInternalTooltip:
      '冷却材が部品内部の流路を通ります — コールドプレートや液冷ブロックなどです。流路が検出されて流体としてメッシュ化され、その周囲の金属がソリッドになります。開口を探して流路を切り出す作業は境界割り当てで行います。',
    passage: '最小流路幅',
    stepNeedsCavity:
      '続行する前に流体キャビティを切り出してください。以降のステップは切り出した面を対象とします。',
    stepNeedsCoolantCarve:
      '続行する前に冷却材を切り出してください。境界層とメッシュ生成は切り出しが終わるまで待機します。',
    applySuggestedSize: '推奨サイズを使用',
    passagePlaceholder: 'mm',
    chtPassageHint:
      '冷却材が通る最も狭い隙間（ミリメートル）。主流路ではなく、最小の穴やスリットを測ってください — これより細い部分は封止され、流れから除外される可能性があります。',
    flowPassageHint:
      '流体が通る最も狭い隙間（ミリメートル）。主流路ではなく、最小の穴やスリットを測ってください — これより細い部分は封止され、流れから除外される可能性があります。値を小さくすると抽出は細かくなり、時間もかかります。',
    flowCavityTitle: '流体キャビティ',
    flowCavityDetect: '検出',
    flowCavityDetecting: '確認中',
    flowCavityDetectInFlight: 'この部品の開口を探しています。約15秒です。',
    flowCavityNeedsDetect:
      'まず部品の開口を確認してください — 約15秒で、下の最小流路幅が自動入力されます。',
    flowCavityCost:
      'このサイズで約 {{cells}}M セル、{{gb}} GB、{{minutes}} 分です。',
    flowCavityPassageFrom_one:
      '最小流路幅 {{value}} mm（開口 {{count}} 箇所から測定）。',
    flowCavityPassageFrom_other:
      '最小流路幅 {{value}} mm（開口 {{count}} 箇所から測定）。',
    flowCavityPassageClamped:
      '{{detected}} mm と測定されましたが、上限を超えるセル数が必要になるため {{suggested}} mm を入力しました。',
    flowCavityTooFine:
      'この部品には細かすぎます — 抽出グリッドが上限を超えます。{{min}} mm 以上にしてください。',
    flowCavityCoarserThanDetected:
      '測定値 {{detected}} mm より粗い設定です。{{set}} mm より細い流路は塞がれる可能性があります。',
    flowCavityExtract: '抽出',
    flowCavityReExtract: '再抽出',
    flowCavityExtracting: '抽出中',
    flowCavityInFlight:
      'この部品から流体キャビティを切り出しています。数分かかります — このページを離れても処理は続きます。',
    flowCavityNeedsPassage:
      'まず上で最小流路幅を設定してください — この値がないと、どの開口を残すか判断できません。',
    flowCavityNameBlank:
      '名前が未入力の面があります。上の壁面名で入力するか、行を削除してください。',
    flowCavityNameRefused:
      'メッシャーは名前「{{name}}」を使用できません。上の壁面名または下のサーフェス一覧で、この面の名前を変更してください。',
    flowCavityUnknown:
      '流体キャビティの有無を確認できませんでした。ページを再読み込みしてください。',
    flowCavityChecking: '流体キャビティを確認中…',
    flowCavityReady:
      '流体キャビティの準備ができました。これを基にメッシュを生成します。',
    flowCavityStale:
      '流体キャビティが現在の設定と一致しません。もう一度抽出してください。',
    flowCavityAbsent:
      'まだ流体キャビティがありません。メッシュ生成の前に抽出してください — ないままだと部品の外側がメッシュ化されます。',
    flowCavityFailed:
      '抽出を開始できませんでした。流路幅を確認して、もう一度お試しください。',
    flowCavityDetectFailed:
      '部品の開口を確認できませんでした。ページを再読み込みしてお試しください。',
    flowCavityRunFailed:
      '前回の抽出は完了しませんでした。原因は次のとおりです：',
    flowCavityTryAgain: '再試行',
    wrapBlockedInternal:
      'この部品は Wrap 前処理でインポートされているため、この流れの種類をメッシュ化できません。使用するには Repair 前処理でファイルを再インポートしてください。',
    wrapBlockedFea:
      'この部品は Wrap 前処理でインポートされ、単一の閉じた表面に統合されています — FEA は境界条件を設定するために元の CAD 面が必要です。FEA を実行するには Repair 前処理でファイルを再インポートしてください。',
    cantMeshSim: '{{type}} をメッシュ化できません：{{reason}}。',
    canStillMeshSim:
      '{{reason}}。{{type}} をメッシュ化することは可能ですが、品質が低下したセルを生成する場合があります。',
    flowType: '流れの種類',
    internalNeedsCavity: '{{reason}}。外部流に切り替えることもできます。',
    chtInternalTooltip:
      '冷却液は部品の内部を流れます。下で抽出し、流体ボディとして指定してください。',
    chtExternalNotYet:
      'この準備方法では、周囲空気による冷却はまだ利用できません。',
    cantMeshExternal: '外部流をメッシュ化できません：{{reason}}。',
    canStillMeshExternal:
      '{{reason}}。外部流をメッシュ化することは可能ですが、風洞のカットが不完全で結果が低下する場合があります。',
    external: '外部',
    internal: '内部',
    element: '要素',
    geometryPrep: 'ジオメトリ前処理',
    geoPrepRepairTooltip:
      'メッシュ化前に CAD を診断・修復します — すき間、非多様体エッジ、不良面を修正します。既定です。',
    geoPrepWrapTooltip:
      '部品をクリーンな水密表面で包み、代わりにそれをメッシュ化します — 汚れたり漏れたりする CAD に対してより堅牢です。部品がそもそもメッシュ化できるかの確認に最適で、面ごとの境界タグはまだ引き継がれません。',
    repair: '修復',
    wrap: 'ラップ',
    preset: 'プリセット',
    // サイズプリセット (Coarse/Medium/Fine) の日本語. 行内に英語も
    // 併記するので日本語は「粗/中/細」の一文字表記で十分.
    presetOptionCoarse: '粗',
    presetOptionMedium: '中',
    presetOptionFine: '細',
    // より細かい 2 段階 — 英語原名との視覚的な対応を保つため
    // 「より細」/「超細」を採用.
    presetOptionVeryFine: 'より細',
    presetOptionUltraFine: '超細',
    presetOptionCustom: 'カスタム',
    unitsDetectedTooltip:
      'ジオメトリは {{unit}} で作成されています（CAD ヘッダーから検出）。バックエンドは求解時にメッシュを SI メートルに再スケールします。',
    unitsPickTooltip:
      'ジオメトリが作成された単位を選択してください。バックエンドは求解時にメッシュを SI メートルに再スケールします。STL/OBJ ファイルには単位ヘッダーがないため、選択が必須です。',
    units: '単位',
    unitPlaceholder: '選択…',
    maxSize: '最大サイズ',
    minSizePlaceholder: '≥1e-7',
    minSize: '最小サイズ',
    meshTooCoarseHex:
      ' Hex メッシュは誤った流れ領域を捕捉します — 最小サイズを小さくするか tet に切り替えてください。',
    meshTooCoarseTet:
      ' Tet メッシュは狭い通路でクラッシュしたり退化要素を生成する場合があります。',
    wrapMeshTooCoarse:
      'セルサイズ {{minSize}} mm では {{passage}} mm の流路が塞がれ、流体の一部だけのきれいなメッシュになります。{{target}} mm 以下にしてください。',
    wrapChtMeshTooCoarse:
      'セルサイズ {{minSize}} mm では {{passage}} mm の冷却流路が塞がれることがあり、その場合メッシュには冷却材の一部しか含まれず、エラーも出ません。{{target}} mm 以下にしてください。',
    meshTooCoarse:
      '最小サイズ（{{minSize}} mm）が最小通路半径（{{radius}} mm）を超えています。{{advice}}',
    boundaryAssignment: '境界割り当て',
    openingNames: {
      heading: '抽出前に開口部に名前を付ける',
      intro_one:
        '検出された開口部に抽出前に名前を付けるか、開口部ではないものとして指定します。空欄では自動命名されます。',
      intro_other:
        '検出された{{count}}個の開口部に抽出前に名前を付けるか、開口部ではないものを指定します。空欄では自動命名されます。',
      across: '直径 {{mm}} mm',
      nameFor: '{{name}}の名前',
      unnamed: '開口部 {{index}}',
      locate: '開口部 {{name}} — フォーカスまたはホバーでビューアに表示',
      detectFirst: 'まず開口部を検出してください。',
      empty: 'このパーツでは開口部が検出されませんでした。',
      ambiguous:
        '同じ幾何学的識別情報を持つ開口部には、安全に名前を付けられません。',
      unmatchedSummary_one:
        '保存された名前または指定 1 件は、このパーツと一致しません。抽出前にクリアしてください。',
      unmatchedSummary_other:
        '保存された名前または指定 {{count}} 件は、このパーツと一致しません。抽出前にクリアしてください。',
      clearAll: 'すべてクリア',
      ignore: '{{name}}を開口部ではないものとして指定',
      restore: '{{name}}を再び開口部として扱う',
      ignoredPlaceholder: '開口部ではない',
      cappedCount_one: '抽出前に1個の開口部を塞ぎます。',
      cappedCount_other: '抽出前に{{count}}個の開口部を塞ぎます。',
      allIgnored:
        'すべての開口部が除外されているため、切り出す開口部がありません。少なくとも 1 つを復元してください。',
      carve: 'この名前で流体領域を抽出',
    },
    wallNames: {
      heading: '壁に名前を付ける',
      intro:
        'ビューアで面を選ぶと、流路壁の一部に名前を付けられます（高温側、低温側など）。名前のない面はすべて 1 つの壁になります。',
      empty:
        '選択された面はありません。ビューアで面を Ctrl+クリックすると、その部分の壁に名前を付けられます。',
      face: 'F{{index}}',
      wasAnOpening:
        '開口として検出されていた面。名前を付けるか、壁のままにします',
      nameFor: 'CAD 面 {{face}} の名前',
      remove: '{{name}} の命名を解除',
      refusal: {
        blank: 'この面に名前を付けるか、削除してください。',
        noValidCharacters:
          '英数字またはアンダースコアを使用してください。この名前には含まれていません。',
        reserved:
          'この名前はメッシャーが使用します。別の名前を選んでください。',
        interfaceInfix: '「_to_」は領域間の接続用に予約されています。',
        autoAssigned: '「opening_」で始まる名前は自動的に割り当てられます。',
        collidesWithOpening:
          'この名前は開口部が使用しています。壁と開口部で同じ名前は使えません。',
        duplicateName:
          '2 つの面が同じパッチになります。スペースとアンダースコアは同じ文字として扱われます。',
      },
    },
    namedSurfaces: '名前付きサーフェス',
    structuralBodies: 'ボディ割り当て',
    bodyClassification: 'ボディ分類',
    bodyClassificationParts_one: '部品 {{count}} 個',
    bodyClassificationParts_other: '部品 {{count}} 個',
    boundaryLayers: '境界層',
    blOn: 'オン · {{count}} 層',
    blOff: 'オフ',
    advanced: '詳細',
    order: '次数',
    orderTet: 'Linear (Tet4)',
    orderTetQuadratic: 'Quadratic (Tet10)',
    orderHex: 'Linear (Hex8)',
    orderPoly: 'Linear (Poly)',
    elementTetTooltip:
      'Tet（テトラヘドラル/四面体）: 4 節点のピラミッド要素。汚れた CAD に強く、gmsh でメッシュ化されます。',
    elementHexTooltip:
      'Hex（ヘキサヘドラル/六面体）: 8 節点のボックス要素。セルあたりの精度が高く、snappyHexMesh でメッシュ化されます。',
    elementPolyTooltip:
      'Poly（ポリヘドラル/多面体）: 任意の面数を持つセル。内部流れを少ないセル数で安定してメッシュ化。cfMesh pMesh でメッシュ化されます。',
    // 「戦略」だけだと軍事的な語感が強くなるので「メッシュ手法」に. OpenFOAM で
    // 選ばれる Tet / Hex 生成アルゴリズムのことで、UI では制御項目.
    strategy: 'メッシュ手法',
    auto: 'Auto',
    // 「タイムアウト」を「打切り時間」に. 「待ち時間」との誤読を避け、
    // 上限を超えたら中断される制御パラメータであることを明示.
    strategyTimeout: 'メッシュ手法の打切り時間（秒）',
    strategyTimeoutHint:
      '各メッシュ化手法（Tet / Hex 等）が中断するまでの最大時間です。空欄の場合は既定を使用します。',
    generalSettings: '基本設定',
    stepContinue: '{{title}}へ進む',
    stepFinish: '設定を完了',
    stepDone: '完了',
    stepsProgress: '{{done}}/{{total}} ステップ',
    stepLockedHint: 'まずステップ{{n}}「{{title}}」を完了してください。',
    stepCtaBlockedHint: 'ステップ{{n}}「{{title}}」を完了してください。',
    cfdOnly: 'CFDのみ',
    notAvailable: 'ここでは利用できません',
  },
  partialMesh: {
    meshingDidNotFinish: 'メッシュ化は完了しませんでした。',
    usableStillWritten:
      '使用可能なメッシュは書き出されました — 実行することはできますが、結果はクリーンなメッシュより信頼性が低い可能性があります。',
  },
  meshFailure: {
    subcellOpening: {
      title: '開口部が 1 つのメッシュセルより小さいです。',
      hint: '開口として解決されるよう近くのメッシュを細分化するか、壁としてメッシュ化されることを許容してください。',
    },
    openingDidNotSurvive: {
      title: 'タグ付けした開口部がメッシュ化を通過できませんでした。',
      hint: 'メッシャーが開口の面を周囲のサーフェスに統合し、パッチが失われました。「CAD 特徴エッジにスナップ」（Engine Overrides → Snap Fidelity）をオンにして開口のエッジを保持するか、近くのメッシュを細分化してから再実行してください。',
    },
    fluidDomainDisconnected: {
      title: '流体領域が完全につながっていません。',
      hint: '流体抽出に切り替えるか、流路が閉じるようにボディを修復してください。',
    },
    cellCapExceeded: {
      title: '完了前にメッシュがセル上限に達しました。',
      hint: '要素サイズを大きくするか領域を縮小して、セル数を減らしてください。',
    },
    snapFailed: {
      title: 'メッシュを CAD 表面にスナップできませんでした。',
      hint: 'CAD を修復するか、スナップ設定を緩めてから再実行してください。',
    },
    layerFailed: {
      title: '一部の壁で境界層を成長させられませんでした。',
      hint: '層数または初期層高さを下げるか、「BL カバレッジを優先」をオンにしてから再実行してください。',
    },
    domainCoverageLost: {
      title: '流体領域の大部分がメッシュ化中に破棄されました。',
      hint: 'メッシャーは内部シード点からキャビティの一部にしか到達できませんでした。多くはセルサイズではなく、自己交差や重複面といった表面欠陥がキャビティを分断していることが原因です。ジオメトリ診断を再実行し、キャビティに欠陥が報告されていれば先に修復してください。最小セルサイズを小さくするのは、流路が実際に狭い場合にのみ有効です。',
    },
    chtPartLabelsMismatch: {
      title: '部品名が正しい部品を指していません。',
      hint: '各名前が正しい部品に付いているか確認してください。正しい場合は、CAD をもう一度アップロードして部品を確認し直してから、名前を付けて再メッシュしてください。名前なしでメッシュ化すると part_0、part_1 などのままになります。',
    },
  },
  qualityWarningCodes: {
    // 「反転セル」— セルのヤコビアンが負の状態. Tet で頂点順が逆、Hex で
    // snap 変形が過剰なときに生じ、解が発散する主要要因.
    invertedCells: '反転セルあり',
    highNonOrtho: '非直交性が高い',
    highSkewness: '歪度が大きい',
    extremeAspect: '極端なアスペクト比のセル',
    snapTornWalls: 'snap で裂けた壁面を検出',
    degenerateCells:
      '体積がほぼゼロのセルあり（薄いスライバー形状が原因の可能性）',
  },
  meshResults: {
    qualityWarnings: '品質警告',
    wedgeCellsTitle:
      'snappyHexMesh addLayers によるプリズム（くさび）セル — 境界層プリズムです。',
    pyramidCellsTitle: '細分化レベル間の遷移セルです。通常は総数の <1 % です。',
    bulkCellsTitle:
      'バルク体積セル = 総数 − くさび。少数のピラミッド遷移セルを含む場合があります（通常 <1 %）。正確なタイプ別内訳はビューアでメッシュを読み込むと確認できます。',
    wedgeCellsFallbackTitle:
      'snappyHexMesh addLayers が生成したプリズムセルです。ゼロは BL 押し出しの失敗を意味します。',
    elements: '要素',
    hexCells: 'Hex セル',
    tetCells: 'Tet セル',
    wedgeCells: 'くさびセル',
    pyramidCells: 'ピラミッドセル',
    polyCells: '多面体セル',
    polyCellsTitle:
      '任意多面体（cfMesh pMesh セル、または snappyHexMesh の分割ヘックス）。実形状のままネイティブ描画されます。',
    copiedToast: 'メッシュパラメータをコピーしました',
    storageWriteFailed: 'ストレージへの書き込みに失敗しました',
    noCopiedToast:
      'コピーされたメッシュパラメータがありません — まずメッシュで「コピー」をクリックしてください',
    corruptToast: '保存されたメッシュパラメータが破損しています',
    notMeshParamsToast: '保存された値はメッシュパラメータではありません',
    appliedToast: 'メッシュパラメータを適用しました',
    strategy: '戦略',
    element: '要素',
    maxSize: '最大サイズ',
    minSize: '最小サイズ',
    order: '次数',
    boundaryLayers: '境界層',
    boundaryLayersValue: '{{value}} 層',
    copy: 'コピー',
    copyTooltip:
      'このメッシュのパラメータをブラウザストレージに保存し、他のメッシュに再適用できるようにします。',
    apply: '適用',
    applyTooltip:
      '最後にコピーしたメッシュパラメータを Mesh Settings に適用します。',
    cancelled: 'キャンセル済み',
    failedAt: '{{stage}} で失敗',
    failed: '失敗',
    stageSuffix: '{{stage}} で停止',
    lastLogLabel: '最新のログ：',
    meshGenerated: 'メッシュを生成しました',
    queuedFor: 'キュー待ち {{time}}',
    bypassActive: 'バイパス有効：入力ゲートをスキップ{{detail}}。',
    bypassRecovery: '該当する箇所は自動復旧でメッシュを生成しました。',
    dirtyCadHintTitle: 'このゲートは省略できます。',
    needsWrapTitle: 'この部品にはラップ前処理が必要です。',
    needsWrapBody:
      'エンクロージャのカットがこの形状をそのまま処理できません。ラップ前処理で再インポートすると、閉じた水密サーフェス 1 枚に封じます。',
    reimportWithWrap: 'ラップで再インポート',
    dirtyCadHintBody:
      '「詳細な上書き → 汚れた CAD の事前チェックゲートをバイパス」をオンにすると、それでもメッシュ化を試みることができます。または、メッシュファイル（STL / OBJ）として再アップロードし「ラップ」オプションを選ぶと、クリーンな CAD が再構築されます。',
    wireballRecovered:
      'メッシュは alpha-wrap エンベロープでワイヤーボールから自動復旧しました。',
    namedSurfacesLost: '名前付きサーフェスが失われました。',
    namedSurfacesLostBody:
      'PyTetwild（最終手段のフォールバック）はすべてのボディを 1 つの tet メッシュに融合し、面ラベルを保持できません。名前付きサーフェスを得るには HXT または Delaunay で再メッシュ化してください。',
    inputSettings: '入力設定',
    errorDetails: 'エラー詳細',
    pipelineStages: 'パイプラインステージ',
    qualitySummary: '品質概要',
    na: 'N/A',
    snapFidelity: 'Snap 忠実度',
    boundaryLayerCoverage: '境界層カバレッジ',
    metricMin: '最小',
    metricMax: '最大',
    metricAvg: '平均',
    metricStd: '標準偏差',
    metricCount: '件数',
    metricTarget: '目標',
    nonOrthogonality: '非直交性',
    max: '最大',
    avg: '平均',
    volume: '体積',
    stageRecovery: '復旧',
    stageGeometryPrep: 'ジオメトリ前処理',
    stageInputCheck: '入力チェック',
    stageBoundaryCheck: '境界チェック',
    stageMeshing: 'メッシュ化',
    stageQuality: '品質',
    stageHealing: 'ヒーリング',
    stageConversion: '変換',
    stageOpenfoamConversion: 'フォーマット変換',
    stagePolymeshAudit: 'メッシュ監査',
    stageLaplacianSmooth: '平滑化',
    stageQualityRetrigger: '品質再実行',
    stageQualityOptimization: '品質最適化',
    stageCavityExtract: 'キャビティ抽出',
    stageChtConvert: 'CHT 変換',
    stageSplitRegions: '領域分割',
    stageCfmesh: '六面体メッシャー',
    stagePolyMesh: 'ポリメッシャー',
    substageCaseBuild: 'セットアップ',
    substageBlockmesh: '背景グリッド',
    substageFeatureExtract: 'エッジ検出',
    substageDecompose: '並列分割',
    substageSnap: '表面フィッティング',
    substageReconstruct: '結果の統合',
    substageSnapEdgeRecovery: 'エッジ復元',
    substageAddLayers: '境界層',
    substageCheckMesh: '品質チェック',
    badgeFluid: '流体',
    badgeSolid: 'ソリッド',
    badgeBl: 'BL',
    logs: 'ログ',
    logsPreparing: '準備中…',
    logsDownloadFailed: 'ログのダウンロードに失敗しました',
    partialMeshTitle: '部分メッシュ',
    partialMeshBody:
      'このメッシュを書き出した後にメッシュ生成が停止しました。ビューアーでプレビューして生成結果を確認してください。不完全な可能性があります。',
    partialMeshCells: 'セル',
    partialMeshCellsTyped: '{{type}} セル',
    partialMeshFluidDomain: '流体領域',
    partialMeshConnected: '連結',
    partialMeshDisconnected: '非連結',
  },
  readinessReason: {
    feaPinchPoint: '部品が一点で自身と接触しています（ピンチポイント）',
    feaNotWatertight:
      '表面にすき間/開いたエッジがあります（閉じた固体ではありません）',
    selfIntersection: '表面同士が交差しています',
    feaTopologyDefect: 'トポロジー欠陥',
    externalNonManifold: 'ボディが内壁/面を共有しています',
    externalOverlap: '2 つ以上のボディが重なっています',
    externalPinchPoint: '部品が一点に窄まっています',
    externalSurfaceDefect: '表面の欠陥',
    internalNoCavity: '密閉された内部空洞を抽出できませんでした',
    internalCavityNotExtracted:
      '流体空洞はまだ抽出されていません — MeshGen の Mesh Settings で Extract を実行してください',
    internalCavityDegraded:
      '流体空洞は抽出されましたが、周辺のジオメトリ欠陥により空洞まわりのメッシュ品質が低下する可能性があります',
    internalNoOpenings:
      '流路開口が検出されなかったため、空洞を抽出する対象がありません — 入口／出口を塞ぐか、ジオメトリを確認してください',
    chtNotConformal:
      'コンフォーマルなマルチリージョンアセンブリではありません（一致するインターフェースを共有する 2 つ以上のボディが必要です）',
    chtRegionNotClosed: 'リージョンが閉じた固体ではありません',
    chtDegenerateFaces: '退化した（面積ゼロの）面',
    chtRegionDefect: 'リージョンの欠陥',
  },
  wrapSuggest: {
    title: 'この部品はメッシュ化に失敗する可能性が高いです',
    description:
      'Diagnosis で{{blockers}}が見つかりました。これらは外部流メッシュ化が依存するドメインカットを壊すため、通常のメッシュ化は失敗します — 多くの場合、数分経ってからです。',
    body: '<b>Wrap</b> 前処理は部品を 1 つのクリーンで水密な表面に封止し、確実にメッシュ化できるようにします。前処理はインポート時に設定されるため、切り替えにはファイルを再インポートします — Wrap オプションが用意されています。',
    continueAnyway: 'このまま続行',
    reimport: 'Wrap で再インポート',
    noSolid: 'ソリッド体積なし（表面のみ）',
    pinch_one: 'ピンチポイント {{count}} 件',
    pinch_other: 'ピンチポイント {{count}} 件',
    overlap_one: '相互貫入ボディ {{count}} 個',
    overlap_other: '相互貫入ボディ {{count}} 個',
    openSurfaces: '開いた表面（隙間）',
    topologyDefects: 'トポロジー欠陥',
  },
  autoRetry: {
    label: 'AIに失敗の修正と再実行を任せる',
    hint: 'メッシュが失敗した場合、または品質基準に届かなかった場合、AIが原因を読み取り、設定を変更して、もう一度実行します。',
    maxAttempts: 'メッシュあたりの再試行回数',
  },
  retry: {
    historyTitle: '再試行履歴',
    historyLoadFailed: '再試行履歴を読み込めませんでした。',
    historyRetry: '再読み込み',
    attempt: '試行 {{n}}',
    originalRun: '最初の実行',
    aiBadge: 'AI · 自動',
    humanBadge: 'AI · 手動',
    platformBadge: 'プラットフォーム再実行',
    convergedBadge: '収束',
    diagnosisHeading: '診断',
    changesHeading: '変更内容',
    humanEdited: '（適用前に編集済み）',
    whatWasTried: 'これまで {{runs}} 回実行 · 自動再試行は最大 {{max}} 回',
    lowConfidenceTitle: 'AIが再試行を提案しています（確信度: 低）',
    escalatedTitle: '確認が必要です',
    declinedTitle: 'AIは再試行を推奨していません',
    applyAndRetry: '適用して再試行',
    acceptBelowPolicy: 'ポリシー未達のまま承認',
    flagForReview: 'レビュー用にフラグ',
    dismiss: '閉じる',
    dismissed: '却下済み',
    notePlaceholder: '任意のメモ…',
    chatAction: 'アドバイザーに聞く',
    chatTooltip: 'このメッシュについてリトライアドバイザーに聞く',
    chatPrompt:
      'メッシュ {{meshId}} は使えるメッシュを生成しなかった. そのメッシュのジオメトリ, パラメータ, 品質指標, ログを読み, こうなった理由と変更すべき点を教えてほしい.',
    chatSessionTitle: 'メッシュリトライ助言 — {{meshId}}',
    retryWithAi: 'AIで再試行',
    retryWithAiTooltip:
      'エージェントが失敗内容を確認し、メッシュ設定を調整して新しい試行として再実行します。',
    retryQueuedToast:
      '再試行を送信しました — エージェントが新しいメッシュ試行をキューに追加しました。',
    retryFailedToast: '再試行に失敗しました: {{message}}',
    appliedToast:
      '提案を適用しました — 新しいメッシュ試行をキューに追加しました。',
    dismissedToast: '提案を却下しました。',
    qualityDelta: '品質 前 → 後',
    policyPass: 'ポリシー合格',
    policyFail: 'ポリシー未達',
    sopVersion: '再試行SOPリビジョン {{v}}',
    copy: 'コピー',
    copied: 'コピーしました',
    copyTooltip:
      '再試行ログ全体をプレーンテキストとしてコピーします — チャットやメッセージにそのまま貼り付けられます。',
    logHeader: '再試行ログ · メッシュ {{id}}',
    markNeedsYou: '要確認',
    markNeedsYouHint: 'AIが修正案を用意しました。実行前に確認してください。',
    markRetrying: 'AIが再試行中',
    markRetryingHint: 'AIが{{n}}回目を実行しています。',
    markFixed: 'AIが修正',
    markFixedHint: '最初の試行は失敗しました。AIが{{n}}回目で修正しました。',
    markStopped: 'AIが中止',
    markStoppedHint_one: 'AIがもう一度試しましたが、修正できませんでした。',
    markStoppedHint_other:
      'AIが{{count}}回試しましたが、修正できませんでした。',
    rollupFixed_one: '{{count}}件を修正',
    rollupFixed_other: '{{count}}件を修正',
    rollupNeedsYou_one: '{{count}}件が要確認',
    rollupNeedsYou_other: '{{count}}件が要確認',
    headerNeedsYou_one: '{{count}}件のメッシュが要確認',
    headerNeedsYou_other: '{{count}}件のメッシュが要確認',
    attemptSwitcherLabel: '試行',
    attemptOutcomeFailed: '失敗',
    attemptOutcomeBelowBar: '基準未満',
    attemptOutcomeRunning: '実行中',
    attemptOutcomeGood: '良好',
    attemptMadeByAi: 'この試行はAIが作成しました',
    attemptMadeByYou: 'あなたの最初の試行',
    attemptChanged: 'AIが変更した内容',
  },
  feaJoins: {
    couplingLabel: 'FEA でボディのペアをつなぐ方法',
    coupling:
      'FEA モデルはボディのペアを次の 3 つのいずれかでつなぎます：\n\n結合：2 つのボディが 1 つの面とその節点を共有します。接合部は引張・せん断・圧縮を伝え、開くことはありません。MeshGen で「共有節点 — 接合」を選んでメッシュすると得られます。\n\nタイ：別々にメッシュした 2 つの面を接着し、節点が揃っていなくても一緒に動くようにします。結合と同じく引張を伝え、開くことはありません。SimOps では熱の伝導用に「結合界面」でタイを追加できます。構造解析では API で設定します。\n\n接触：面同士は押し合いますが離れることができ、摩擦を設定しない限り滑ります。引張は伝えず、解析は非線形になります。SimOps の「接触」で追加します。\n\nタイと接触には、メッシュがマージしなかった面が必要です。節点共有メッシュの隙間か、「独立部品」でメッシュしたペアです。',
    bonded: '結合',
    bondedCaption: '1 つの面、共有の節点。',
    tie: 'タイ',
    tieCaption: '2 つのメッシュを接着。',
    contact: '接触',
    contactCaption: '押し合い、離れたり滑ったりする。',
    couplingThermalLabel: '熱伝導でボディのペアをつなぐ方法',
    couplingThermal:
      '熱伝導モデルはボディのペアを次の 2 つのいずれかでつなぎます：\n\n結合：2 つのボディが 1 つの面とその節点を共有し、熱はその面を自由に通ります。MeshGen で「共有節点 — 接合」を選んでメッシュすると得られます。\n\nタイ：別々にメッシュした 2 つの面を接着し、節点が揃っていなくても同じ温度になるようにします。ここの「結合界面」でタイを追加します。最初に選んだ面が従属側です。\n\n結合もタイもなく接しているだけの面は熱を伝えません。タイには、メッシュがマージしなかった面が必要です。節点共有メッシュの隙間か、「独立部品」でメッシュしたペアです。',
  },
} as const;
